import { Injectable } from '@angular/core';
import { Microservices } from '../../microservices';

@Injectable()
export class ConstantsService {
  public colorTheme = 'theme-default';


  private shipment = {
    states: {
      open: 'open',
      new: 'new',
      readyForPickup: 'readyForPickup',
      booked: 'booked',
      inTransit: 'inTransit',
      awarded: 'awarded',
      delivered: 'delivered'
    }
  };

  private optionsZipcode = {
    types: ['(regions)'],
    componentRestrictions: {
      country: ['US', 'CA']
    }
  };
  /**
   *@const list step  menu side left
   * */
  public stepsMenuCarrier: Array<any> = [
    {
      element: '#dashboard',
      intro: 'See load locations, bids and notifications.',
      position: 'right',
      accesslevel: ['admin']
    },
    {
      element: '#assets',
      intro: 'Manage your assets: add, remove, or edit your equipment and drivers.',
      position: 'right',
      role: ['carrier', 'carrier admin'],
    },
    {
      element: '#shipment',
      intro: 'This is your shipments list: search for new shipments, negotiate, book, and check for updates',
      position: 'right',
      role: ['carrier', 'carrier admin', 'shipper', 'broker'],
    },
    {
      element: '#tracking',
      intro: 'Track your shipments in real-time.',
      position: 'right',
      role: ['carrier', 'carrier admin', 'shipper', 'broker'],
    },
    {
      element: '#payments',
      intro: ' Check your incoming payments, and manage your payment settings.\n',
      position: 'right',
      role: ['carrier', 'carrier admin', 'shipper', 'broker'],
    },
    {
      element: '#invoice',
      intro: 'Manage your invoices and receivables\n',
      position: 'right',
      // role: ['carrier', 'carrier admin', 'shipper', 'broker'],
      accesslevel: ['admin']
    },
    {
      element: '#analytics',
      intro: "Review your company's performance",
      position: 'right',
      // role: ['carrier', 'carrier admin', 'shipper', 'broker'],
      accesslevel: ['admin']
    },
    {
      element: '#settings',
      intro: 'Manage all your account settings such as profile, company information, users, documents, and shipment preferences.',
      position: 'right',
      role: ['carrier', 'carrier admin', 'shipper', 'broker'],
    },
    {
      element: '#tutorial',
      intro: 'Activate the user walkthrough.',
      position: 'right',
      role: ['carrier', 'carrier admin', 'shipper', 'broker'],
    },
    {
      element: '#exclamation',
      intro: 'Revisa todas las acciones pendientes para completar tus reservas de carga.',
      position: 'right',
      role: ['carrier', 'carrier admin', 'shipper', 'broker'],
    },
  ];
  public stepsMenuBroker: Array<any> = [
    {
      element: '#exclamation',
      intro: 'Revisa todas las acciones pendientes para completar tus reservas de carga.',
      position: 'right',
      role: ['carrier', 'carrier admin', 'shipper', 'broker'],
    },
    {
      element: '#tutorial',
      intro: 'Activate the user walkthrough.',
      position: 'right',
      role: ['carrier', 'carrier admin', 'shipper', 'broker'],
    }
  ];
  private pickupTimes = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00',
    '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
    '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
    '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];


  private permits = {
    shipper: [
      { url: 'app/shipment', name: 'Shipment List' },
      { url: 'app/shipment/create', name: 'Create Shipment' },
      { url: 'app/shipment/update', name: 'Update Shipment' },
      { url: 'app/shipment/details', name: 'Shipment Details' },
      { url: 'app/users', name: 'User List' },
      { url: 'app/locations', name: 'Locations' }
    ],
    carrier: [
      { url: 'app/shipment', name: 'Shipment List' },
      { url: 'app/shipment/details', name: 'Shipment Details' },
      { url: 'app/shipment/complete', name: 'Complete Shipment' },
      { url: 'app/users', name: 'User List' },
      { url: 'app/locations', name: 'Locations' },
      { url: 'app/assets/driver', name: 'Drvier' }
    ], // ['truckloads.carriers'],
    trucker: ['app/pptrucker'],
    login: ['/']
  };

  private routes = [
    { url: 'app/settings', name: 'Settings', roles: ['shipper', 'carrier', 'broker'] },
    { url: 'app/settings/users', name: 'Users', roles: ['shipper', 'carrier', 'broker'] },
    { url: 'app/settings/locations', name: 'Locations', roles: ['shipper', 'carrier', 'broker'] },
    { url: 'app/shipment', name: 'Shipment List', roles: ['shipper', 'carrier', 'broker'] },
    { url: 'app/shipment/create', name: 'Create Shipment', roles: ['shipper', 'broker'] },
    { url: 'app/shipment/update', name: 'Update Shipment', roles: ['shipper', 'broker'] },
    { url: 'app/shipment/details', name: 'Shipment Details', roles: ['shipper', 'broker', 'carrier'] },
    { url: 'app/users', name: 'User List', roles: ['shipper', 'broker', 'carrier'] },
    { url: 'app/locations', name: 'Locations', roles: ['shipper', 'broker', 'carrier'] },
    { url: 'app/shipment/complete', name: 'Complete Shipment', roles: ['carrier'] },
    { url: 'app/assets/driver', name: 'Drvier', roles: ['carrier'] },
    { url: 'app/faq', name: 'Faq', roles: ['shipper', 'broker', 'carrier'] },
    { url: 'app/invoice', name: 'Invoice', roles: ['shipper', 'broker', 'carrier'] },
    { url: 'app/customers', name: 'Customers', roles: ['broker'] },
    { url: 'app/shipment/search', name: 'Shipment List', roles: ['shipper', 'carrier', 'broker'] },
    { url: 'app/shipment/myShipments', name: 'My Shipments', roles: ['shipper', 'carrier'] },
  ];

  private US_STATES = [
    'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE',
    'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN',
    'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI',
    'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM',
    'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA',
    'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI',
    'VA', 'WA', 'WV', 'WI', 'WY'];

  private TOUR = {
    LOGIN: 1,
    LIST: 2,
    CREATE: 4,
    new: 8,
    open: 16,
    awarded: 32,
    menu: 64,
    PRICING: 84
  };


  private unidades = {
    longitud: [
      { name: 'Meter', abrv: 'm' },
      { name: 'Inch', abrv: 'in' },
      { name: 'Centimeter', abrv: 'cm' }
    ],
    masa: [
      { name: 'Kilogram', abrv: 'Kg' },
      { name: 'Ton', abrv: 'Tn' }
    ]
  };

  private roles = {
    shipper: 'shipper',
    broker: 'broker',
    carrier: 'carrier'
  };

  private opens = [false, false, false, false, false, false, false, false, false, false];

  private blockchainStages = {
    'stage1': 'ON MY WAY',
    'stage2': 'ARRIVED TO SHIPPER',
    'stage3': 'LOADING',
    'stage31': 'LOADED',
    'stage4': 'IN TRANSIT',
    'stage5': 'ARRIVED TO CONSIGNEE',
    'stage6': 'DROP OFF',
    'stage7': 'DELIVERED'
  };

  private statesUSA = [
    {
      name: 'Alabama',
      abrv: 'AL',
      cities: [
        'Birmingham',
        'Montgomery',
        'Mobile',
        'Huntsville',
        'Tuscaloosa',
        'Hoover',
        'Dothan',
        'Auburn',
        'Decatur',
        'Madison',
        'Florence',
        'Gadsden'
      ]
    },
    {
      name: 'Alaska',
      abrv: 'AK',
      cities: [
        'Anchorage'
      ]
    },
    {
      name: 'American Samoa',
      abrv: 'AS',
      cities: []
    },
    {
      name: 'Arizona',
      abrv: 'AZ',
      cities: [
        'Phoenix',
        'Tucson',
        'Mesa',
        'Chandler',
        'Glendale',
        'Scottsdale',
        'Gilbert',
        'Tempe',
        'Peoria',
        'Surprise',
        'Yuma',
        'Avondale',
        'Goodyear',
        'Flagstaff',
        'Buckeye',
        'Lake Havasu City',
        'Casa Grande',
        'Sierra Vista',
        'Maricopa',
        'Oro Valley',
        'Prescott',
        'Bullhead City',
        'Prescott Valley',
        'Marana',
        'Apache Junction'
      ]
    },
    {
      name: 'Arkansas',
      abrv: 'AR',
      cities: [
        'Little Rock',
        'Fort Smith',
        'Fayetteville',
        'Springdale',
        'Jonesboro',
        'North Little Rock',
        'Conway',
        'Rogers',
        'Pine Bluff',
        'Bentonville'
      ]
    },
    {
      name: 'California',
      abrv: 'CA',
      cities: [
        'Los Angeles',
        'San Diego',
        'San Jose',
        'San Francisco',
        'Fresno',
        'Sacramento',
        'Long Beach',
        'Oakland',
        'Bakersfield',
        'Anaheim',
        'Santa Ana',
        'Riverside',
        'Stockton',
        'Chula Vista',
        'Irvine',
        'Fremont',
        'San Bernardino',
        'Modesto',
        'Fontana',
        'Oxnard',
        'Moreno Valley',
        'Huntington Beach',
        'Glendale',
        'Santa Clarita',
        'Garden Grove',
        'Oceanside',
        'Rancho Cucamonga',
        'Santa Rosa',
        'Ontario',
        'Lancaster',
        'Elk Grove',
        'Corona',
        'Palmdale',
        'Salinas',
        'Pomona',
        'Hayward',
        'Escondido',
        'Torrance',
        'Sunnyvale',
        'Orange',
        'Fullerton',
        'Pasadena',
        'Thousand Oaks',
        'Visalia',
        'Simi Valley',
        'Concord',
        'Roseville',
        'Victorville',
        'Santa Clara',
        'Vallejo',
        'Berkeley',
        'El Monte',
        'Downey',
        'Costa Mesa',
        'Inglewood',
        'Carlsbad',
        'San Buenaventura (Ventura)',
        'Fairfield',
        'West Covina',
        'Murrieta',
        'Richmond',
        'Norwalk',
        'Antioch',
        'Temecula',
        'Burbank',
        'Daly City',
        'Rialto',
        'Santa Maria',
        'El Cajon',
        'San Mateo',
        'Clovis',
        'Compton',
        'Jurupa Valley',
        'Vista',
        'South Gate',
        'Mission Viejo',
        'Vacaville',
        'Carson',
        'Hesperia',
        'Santa Monica',
        'Westminster',
        'Redding',
        'Santa Barbara',
        'Chico',
        'Newport Beach',
        'San Leandro',
        'San Marcos',
        'Whittier',
        'Hawthorne',
        'Citrus Heights',
        'Tracy',
        'Alhambra',
        'Livermore',
        'Buena Park',
        'Menifee',
        'Hemet',
        'Lakewood',
        'Merced',
        'Chino',
        'Indio',
        'Redwood City',
        'Lake Forest',
        'Napa',
        'Tustin',
        'Bellflower',
        'Mountain View',
        'Chino Hills',
        'Baldwin Park',
        'Alameda',
        'Upland',
        'San Ramon',
        'Folsom',
        'Pleasanton',
        'Union City',
        'Perris',
        'Manteca',
        'Lynwood',
        'Apple Valley',
        'Redlands',
        'Turlock',
        'Milpitas',
        'Redondo Beach',
        'Rancho Cordova',
        'Yorba Linda',
        'Palo Alto',
        'Davis',
        'Camarillo',
        'Walnut Creek',
        'Pittsburg',
        'South San Francisco',
        'Yuba City',
        'San Clemente',
        'Laguna Niguel',
        'Pico Rivera',
        'Montebello',
        'Lodi',
        'Madera',
        'Santa Cruz',
        'La Habra',
        'Encinitas',
        'Monterey Park',
        'Tulare',
        'Cupertino',
        'Gardena',
        'National City',
        'Rocklin',
        'Petaluma',
        'Huntington Park',
        'San Rafael',
        'La Mesa',
        'Arcadia',
        'Fountain Valley',
        'Diamond Bar',
        'Woodland',
        'Santee',
        'Lake Elsinore',
        'Porterville',
        'Paramount',
        'Eastvale',
        'Rosemead',
        'Hanford',
        'Highland',
        'Brentwood',
        'Novato',
        'Colton',
        'Cathedral City',
        'Delano',
        'Yucaipa',
        'Watsonville',
        'Placentia',
        'Glendora',
        'Gilroy',
        'Palm Desert',
        'Cerritos',
        'West Sacramento',
        'Aliso Viejo',
        'Poway',
        'La Mirada',
        'Rancho Santa Margarita',
        'Cypress',
        'Dublin',
        'Covina',
        'Azusa',
        'Palm Springs',
        'San Luis Obispo',
        'Ceres',
        'San Jacinto',
        'Lincoln',
        'Newark',
        'Lompoc',
        'El Centro',
        'Danville',
        'Bell Gardens',
        'Coachella',
        'Rancho Palos Verdes',
        'San Bruno',
        'Rohnert Park',
        'Brea',
        'La Puente',
        'Campbell',
        'San Gabriel',
        'Beaumont',
        'Morgan Hill',
        'Culver City',
        'Calexico',
        'Stanton',
        'La Quinta',
        'Pacifica',
        'Montclair',
        'Oakley',
        'Monrovia',
        'Los Banos',
        'Martinez'
      ]
    },
    {
      name: 'Colorado',
      abrv: 'CO',
      cities: [
        'Denver',
        'Colorado Springs',
        'Aurora',
        'Fort Collins',
        'Lakewood',
        'Thornton',
        'Arvada',
        'Westminster',
        'Pueblo',
        'Centennial',
        'Boulder',
        'Greeley',
        'Longmont',
        'Loveland',
        'Grand Junction',
        'Broomfield',
        'Castle Rock',
        'Commerce City',
        'Parker',
        'Littleton',
        'Northglenn'
      ]
    },
    {
      name: 'Connecticut',
      abrv: 'CT',
      cities: [
        'Bridgeport',
        'New Haven',
        'Stamford',
        'Hartford',
        'Waterbury',
        'Norwalk',
        'Danbury',
        'New Britain',
        'Meriden',
        'Bristol',
        'West Haven',
        'Milford',
        'Middletown',
        'Norwich',
        'Shelton'
      ]
    },
    {
      name: 'Delaware',
      abrv: 'DE',
      cities: [
        'Wilmington',
        'Dover'
      ]
    },
    {
      name: 'District Of Columbia',
      abrv: 'DC',
      cities: [
        'Washington'
      ]
    },
    {
      name: 'Federated States Of Micronesia',
      abrv: 'FM',
      cities: []
    },
    {
      name: 'Florida',
      abrv: 'FL',
      cities: [
        'Jacksonville',
        'Miami',
        'Tampa',
        'Orlando',
        'St. Petersburg',
        'Hialeah',
        'Tallahassee',
        'Fort Lauderdale',
        'Port St. Lucie',
        'Cape Coral',
        'Pembroke Pines',
        'Hollywood',
        'Miramar',
        'Gainesville',
        'Coral Springs',
        'Miami Gardens',
        'Clearwater',
        'Palm Bay',
        'Pompano Beach',
        'West Palm Beach',
        'Lakeland',
        'Davie',
        'Miami Beach',
        'Sunrise',
        'Plantation',
        'Boca Raton',
        'Deltona',
        'Largo',
        'Deerfield Beach',
        'Palm Coast',
        'Melbourne',
        'Boynton Beach',
        'Lauderhill',
        'Weston',
        'Fort Myers',
        'Kissimmee',
        'Homestead',
        'Tamarac',
        'Delray Beach',
        'Daytona Beach',
        'North Miami',
        'Wellington',
        'North Port',
        'Jupiter',
        'Ocala',
        'Port Orange',
        'Margate',
        'Coconut Creek',
        'Sanford',
        'Sarasota',
        'Pensacola',
        'Bradenton',
        'Palm Beach Gardens',
        'Pinellas Park',
        'Coral Gables',
        'Doral',
        'Bonita Springs',
        'Apopka',
        'Titusville',
        'North Miami Beach',
        'Oakland Park',
        'Fort Pierce',
        'North Lauderdale',
        'Cutler Bay',
        'Altamonte Springs',
        'St. Cloud',
        'Greenacres',
        'Ormond Beach',
        'Ocoee',
        'Hallandale Beach',
        'Winter Garden',
        'Aventura'
      ]
    },
    {
      name: 'Georgia',
      abrv: 'GA',
      cities: [
        'Atlanta',
        'Columbus',
        'Augusta-Richmond County',
        'Savannah',
        'Athens-Clarke County',
        'Sandy Springs',
        'Roswell',
        'Macon',
        'Johns Creek',
        'Albany',
        'Warner Robins',
        'Alpharetta',
        'Marietta',
        'Valdosta',
        'Smyrna',
        'Dunwoody'
      ]
    },
    {
      name: 'Guam',
      abrv: 'GU',
      cities: []
    },
    {
      name: 'Hawaii',
      abrv: 'HI',
      cities: [
        'Honolulu'
      ]
    },
    {
      name: 'Idaho',
      abrv: 'ID',
      cities: [
        'Boise City',
        'Nampa',
        'Meridian',
        'Idaho Falls',
        'Pocatello',
        'Caldwell',
        'Coeur d\'Alene',
        'Twin Falls'
      ]
    },
    {
      name: 'Illinois',
      abrv: 'IL',
      cities: [
        'Chicago',
        'Aurora',
        'Rockford',
        'Joliet',
        'Naperville',
        'Springfield',
        'Peoria',
        'Elgin',
        'Waukegan',
        'Cicero',
        'Champaign',
        'Bloomington',
        'Arlington Heights',
        'Evanston',
        'Decatur',
        'Schaumburg',
        'Bolingbrook',
        'Palatine',
        'Skokie',
        'Des Plaines',
        'Orland Park',
        'Tinley Park',
        'Oak Lawn',
        'Berwyn',
        'Mount Prospect',
        'Normal',
        'Wheaton',
        'Hoffman Estates',
        'Oak Park',
        'Downers Grove',
        'Elmhurst',
        'Glenview',
        'DeKalb',
        'Lombard',
        'Belleville',
        'Moline',
        'Buffalo Grove',
        'Bartlett',
        'Urbana',
        'Quincy',
        'Crystal Lake',
        'Plainfield',
        'Streamwood',
        'Carol Stream',
        'Romeoville',
        'Rock Island',
        'Hanover Park',
        'Carpentersville',
        'Wheeling',
        'Park Ridge',
        'Addison',
        'Calumet City'
      ]
    },
    {
      name: 'Indiana',
      abrv: 'IN',
      cities: [
        'Indianapolis',
        'Fort Wayne',
        'Evansville',
        'South Bend',
        'Carmel',
        'Bloomington',
        'Fishers',
        'Hammond',
        'Gary',
        'Muncie',
        'Lafayette',
        'Terre Haute',
        'Kokomo',
        'Anderson',
        'Noblesville',
        'Greenwood',
        'Elkhart',
        'Mishawaka',
        'Lawrence',
        'Jeffersonville',
        'Columbus',
        'Portage'
      ]
    },
    {
      name: 'Iowa',
      abrv: 'IA',
      cities: [
        'Des Moines',
        'Cedar Rapids',
        'Davenport',
        'Sioux City',
        'Iowa City',
        'Waterloo',
        'Council Bluffs',
        'Ames',
        'West Des Moines',
        'Dubuque',
        'Ankeny',
        'Urbandale',
        'Cedar Falls'
      ]
    },
    {
      name: 'Kansas',
      abrv: 'KS',
      cities: [
        'Wichita',
        'Overland Park',
        'Kansas City',
        'Olathe',
        'Topeka',
        'Lawrence',
        'Shawnee',
        'Manhattan',
        'Lenexa',
        'Salina',
        'Hutchinson'
      ]
    },
    {
      name: 'Kentucky',
      abrv: 'KY',
      cities: [
        'Louisville/Jefferson County',
        'Lexington-Fayette',
        'Bowling Green',
        'Owensboro',
        'Covington'
      ]
    },
    {
      name: 'Louisiana',
      abrv: 'LA',
      cities: [
        'New Orleans',
        'Baton Rouge',
        'Shreveport',
        'Lafayette',
        'Lake Charles',
        'Kenner',
        'Bossier City',
        'Monroe',
        'Alexandria'
      ]
    },
    {
      name: 'Maine',
      abrv: 'ME',
      cities: [
        'Portland'
      ]
    },
    {
      name: 'Marshall Islands',
      abrv: 'MH',
      cities: []
    },
    {
      name: 'Maryland',
      abrv: 'MD',
      cities: [
        'Baltimore',
        'Frederick',
        'Rockville',
        'Gaithersburg',
        'Bowie',
        'Hagerstown',
        'Annapolis'
      ]
    },
    {
      name: 'Massachusetts',
      abrv: 'MA',
      cities: [
        'Boston',
        'Worcester',
        'Springfield',
        'Lowell',
        'Cambridge',
        'New Bedford',
        'Brockton',
        'Quincy',
        'Lynn',
        'Fall River',
        'Newton',
        'Lawrence',
        'Somerville',
        'Waltham',
        'Haverhill',
        'Malden',
        'Medford',
        'Taunton',
        'Chicopee',
        'Weymouth Town',
        'Revere',
        'Peabody',
        'Methuen',
        'Barnstable Town',
        'Pittsfield',
        'Attleboro',
        'Everett',
        'Salem',
        'Westfield',
        'Leominster',
        'Fitchburg',
        'Beverly',
        'Holyoke',
        'Marlborough',
        'Woburn',
        'Chelsea'
      ]
    },
    {
      name: 'Michigan',
      abrv: 'MI',
      cities: [
        'Detroit',
        'Grand Rapids',
        'Warren',
        'Sterling Heights',
        'Ann Arbor',
        'Lansing',
        'Flint',
        'Dearborn',
        'Livonia',
        'Westland',
        'Troy',
        'Farmington Hills',
        'Kalamazoo',
        'Wyoming',
        'Southfield',
        'Rochester Hills',
        'Taylor',
        'Pontiac',
        'St. Clair Shores',
        'Royal Oak',
        'Novi',
        'Dearborn Heights',
        'Battle Creek',
        'Saginaw',
        'Kentwood',
        'East Lansing',
        'Roseville',
        'Portage',
        'Midland',
        'Lincoln Park',
        'Muskegon'
      ]
    },
    {
      name: 'Minnesota',
      abrv: 'MN',
      cities: [
        'Minneapolis',
        'St. Paul',
        'Rochester',
        'Duluth',
        'Bloomington',
        'Brooklyn Park',
        'Plymouth',
        'St. Cloud',
        'Eagan',
        'Woodbury',
        'Maple Grove',
        'Eden Prairie',
        'Coon Rapids',
        'Burnsville',
        'Blaine',
        'Lakeville',
        'Minnetonka',
        'Apple Valley',
        'Edina',
        'St. Louis Park',
        'Mankato',
        'Maplewood',
        'Moorhead',
        'Shakopee'
      ]
    },
    {
      name: 'Mississippi',
      abrv: 'MS',
      cities: [
        'Jackson',
        'Gulfport',
        'Southaven',
        'Hattiesburg',
        'Biloxi',
        'Meridian'
      ]
    },
    {
      name: 'Missouri',
      abrv: 'MO',
      cities: [
        'Kansas City',
        'St. Louis',
        'Springfield',
        'Independence',
        'Columbia',
        'Lee\'s Summit',
        'O\'Fallon',
        'St. Joseph',
        'St. Charles',
        'St. Peters',
        'Blue Springs',
        'Florissant',
        'Joplin',
        'Chesterfield',
        'Jefferson City',
        'Cape Girardeau'
      ]
    },
    {
      name: 'Montana',
      abrv: 'MT',
      cities: [
        'Billings',
        'Missoula',
        'Great Falls',
        'Bozeman'
      ]
    },
    {
      name: 'Nebraska',
      abrv: 'NE',
      cities: [
        'Omaha',
        'Lincoln',
        'Bellevue',
        'Grand Island'
      ]
    },
    {
      name: 'Nevada',
      abrv: 'NV',
      cities: [
        'Las Vegas',
        'Henderson',
        'Reno',
        'North Las Vegas',
        'Sparks',
        'Carson City'
      ]
    },
    {
      name: 'New Hampshire',
      abrv: 'NH',
      cities: [
        'Manchester',
        'Nashua',
        'Concord'
      ]
    },
    {
      name: 'New Jersey',
      abrv: 'NJ',
      cities: [
        'Newark',
        'Jersey City',
        'Paterson',
        'Elizabeth',
        'Clifton',
        'Trenton',
        'Camden',
        'Passaic',
        'Union City',
        'Bayonne',
        'East Orange',
        'Vineland',
        'New Brunswick',
        'Hoboken',
        'Perth Amboy',
        'West New York',
        'Plainfield',
        'Hackensack',
        'Sayreville',
        'Kearny',
        'Linden',
        'Atlantic City'
      ]
    },
    {
      name: 'New Mexico',
      abrv: 'NM',
      cities: [
        'Albuquerque',
        'Las Cruces',
        'Rio Rancho',
        'Santa Fe',
        'Roswell',
        'Farmington',
        'Clovis'
      ]
    },
    {
      name: 'New York',
      abrv: 'NY',
      cities: [
        'New York',
        'Buffalo',
        'Rochester',
        'Yonkers',
        'Syracuse',
        'Albany',
        'New Rochelle',
        'Mount Vernon',
        'Schenectady',
        'Utica',
        'White Plains',
        'Hempstead',
        'Troy',
        'Niagara Falls',
        'Binghamton',
        'Freeport',
        'Valley Stream'
      ]
    },
    {
      name: 'North Carolina',
      abrv: 'NC',
      cities: [
        'Charlotte',
        'Raleigh',
        'Greensboro',
        'Durham',
        'Winston-Salem',
        'Fayetteville',
        'Cary',
        'Wilmington',
        'High Point',
        'Greenville',
        'Asheville',
        'Concord',
        'Gastonia',
        'Jacksonville',
        'Chapel Hill',
        'Rocky Mount',
        'Burlington',
        'Wilson',
        'Huntersville',
        'Kannapolis',
        'Apex',
        'Hickory',
        'Goldsboro'
      ]
    },
    {
      name: 'North Dakota',
      abrv: 'ND',
      cities: [
        'Fargo',
        'Bismarck',
        'Grand Forks',
        'Minot'
      ]
    },
    {
      name: 'Northern Mariana Islands',
      abrv: 'MP',
      cities: []
    },
    {
      name: 'Ohio',
      abrv: 'OH',
      cities: [
        'Columbus',
        'Cleveland',
        'Cincinnati',
        'Toledo',
        'Akron',
        'Dayton',
        'Parma',
        'Canton',
        'Youngstown',
        'Lorain',
        'Hamilton',
        'Springfield',
        'Kettering',
        'Elyria',
        'Lakewood',
        'Cuyahoga Falls',
        'Middletown',
        'Euclid',
        'Newark',
        'Mansfield',
        'Mentor',
        'Beavercreek',
        'Cleveland Heights',
        'Strongsville',
        'Dublin',
        'Fairfield',
        'Findlay',
        'Warren',
        'Lancaster',
        'Lima',
        'Huber Heights',
        'Westerville',
        'Marion',
        'Grove City'
      ]
    },
    {
      name: 'Oklahoma',
      abrv: 'OK',
      cities: [
        'Oklahoma City',
        'Tulsa',
        'Norman',
        'Broken Arrow',
        'Lawton',
        'Edmond',
        'Moore',
        'Midwest City',
        'Enid',
        'Stillwater',
        'Muskogee'
      ]
    },
    {
      name: 'Oregon',
      abrv: 'OR',
      cities: [
        'Portland',
        'Eugene',
        'Salem',
        'Gresham',
        'Hillsboro',
        'Beaverton',
        'Bend',
        'Medford',
        'Springfield',
        'Corvallis',
        'Albany',
        'Tigard',
        'Lake Oswego',
        'Keizer'
      ]
    },
    {
      name: 'Palau',
      abrv: 'PW',
      cities: []
    },
    {
      name: 'Pennsylvania',
      abrv: 'PA',
      cities: [
        'Philadelphia',
        'Pittsburgh',
        'Allentown',
        'Erie',
        'Reading',
        'Scranton',
        'Bethlehem',
        'Lancaster',
        'Harrisburg',
        'Altoona',
        'York',
        'State College',
        'Wilkes-Barre'
      ]
    },
    {
      name: 'Puerto Rico',
      abrv: 'PR',
      cities: []
    },
    {
      name: 'Rhode Island',
      abrv: 'RI',
      cities: [
        'Providence',
        'Warwick',
        'Cranston',
        'Pawtucket',
        'East Providence',
        'Woonsocket'
      ]
    },
    {
      name: 'South Carolina',
      abrv: 'SC',
      cities: [
        'Columbia',
        'Charleston',
        'North Charleston',
        'Mount Pleasant',
        'Rock Hill',
        'Greenville',
        'Summerville',
        'Sumter',
        'Goose Creek',
        'Hilton Head Island',
        'Florence',
        'Spartanburg'
      ]
    },
    {
      name: 'South Dakota',
      abrv: 'SD',
      cities: [
        'Sioux Falls',
        'Rapid City'
      ]
    },
    {
      name: 'Tennessee',
      abrv: 'TN',
      cities: [
        'Memphis',
        'Nashville-Davidson',
        'Knoxville',
        'Chattanooga',
        'Clarksville',
        'Murfreesboro',
        'Jackson',
        'Franklin',
        'Johnson City',
        'Bartlett',
        'Hendersonville',
        'Kingsport',
        'Collierville',
        'Cleveland',
        'Smyrna',
        'Germantown',
        'Brentwood'
      ]
    },
    {
      name: 'Texas',
      abrv: 'TX',
      cities: [
        'Houston',
        'San Antonio',
        'Dallas',
        'Austin',
        'Fort Worth',
        'El Paso',
        'Arlington',
        'Corpus Christi',
        'Plano',
        'Laredo',
        'Lubbock',
        'Garland',
        'Irving',
        'Amarillo',
        'Grand Prairie',
        'Brownsville',
        'Pasadena',
        'McKinney',
        'Mesquite',
        'McAllen',
        'Killeen',
        'Frisco',
        'Waco',
        'Carrollton',
        'Denton',
        'Midland',
        'Abilene',
        'Beaumont',
        'Round Rock',
        'Odessa',
        'Wichita Falls',
        'Richardson',
        'Lewisville',
        'Tyler',
        'College Station',
        'Pearland',
        'San Angelo',
        'Allen',
        'League City',
        'Sugar Land',
        'Longview',
        'Edinburg',
        'Mission',
        'Bryan',
        'Baytown',
        'Pharr',
        'Temple',
        'Missouri City',
        'Flower Mound',
        'Harlingen',
        'North Richland Hills',
        'Victoria',
        'Conroe',
        'New Braunfels',
        'Mansfield',
        'Cedar Park',
        'Rowlett',
        'Port Arthur',
        'Euless',
        'Georgetown',
        'Pflugerville',
        'DeSoto',
        'San Marcos',
        'Grapevine',
        'Bedford',
        'Galveston',
        'Cedar Hill',
        'Texas City',
        'Wylie',
        'Haltom City',
        'Keller',
        'Coppell',
        'Rockwall',
        'Huntsville',
        'Duncanville',
        'Sherman',
        'The Colony',
        'Burleson',
        'Hurst',
        'Lancaster',
        'Texarkana',
        'Friendswood',
        'Weslaco'
      ]
    },
    {
      name: 'Utah',
      abrv: 'UT',
      cities: [
        'Salt Lake City',
        'West Valley City',
        'Provo',
        'West Jordan',
        'Orem',
        'Sandy',
        'Ogden',
        'St. George',
        'Layton',
        'Taylorsville',
        'South Jordan',
        'Lehi',
        'Logan',
        'Murray',
        'Draper',
        'Bountiful',
        'Riverton',
        'Roy'
      ]
    },
    {
      name: 'Vermont',
      abrv: 'VT',
      cities: [
        'Burlington'
      ]
    },
    {
      name: 'Virgin Islands',
      abrv: 'VI',
      cities: []
    },
    {
      name: 'Virginia',
      abrv: 'VA',
      cities: [
        'Virginia Beach',
        'Norfolk',
        'Chesapeake',
        'Richmond',
        'Newport News',
        'Alexandria',
        'Hampton',
        'Roanoke',
        'Portsmouth',
        'Suffolk',
        'Lynchburg',
        'Harrisonburg',
        'Leesburg',
        'Charlottesville',
        'Danville',
        'Blacksburg',
        'Manassas'
      ]
    },
    {
      name: 'Washington',
      abrv: 'WA',
      cities: [
        'Seattle',
        'Spokane',
        'Tacoma',
        'Vancouver',
        'Bellevue',
        'Kent',
        'Everett',
        'Renton',
        'Yakima',
        'Federal Way',
        'Spokane Valley',
        'Bellingham',
        'Kennewick',
        'Auburn',
        'Pasco',
        'Marysville',
        'Lakewood',
        'Redmond',
        'Shoreline',
        'Richland',
        'Kirkland',
        'Burien',
        'Sammamish',
        'Olympia',
        'Lacey',
        'Edmonds',
        'Bremerton',
        'Puyallup'
      ]
    },
    {
      name: 'West Virginia',
      abrv: 'WV',
      cities: [
        'Charleston',
        'Huntington'
      ]
    },
    {
      name: 'Wisconsin',
      abrv: 'WI',
      cities: [
        'Milwaukee',
        'Madison',
        'Green Bay',
        'Kenosha',
        'Racine',
        'Appleton',
        'Waukesha',
        'Eau Claire',
        'Oshkosh',
        'Janesville',
        'West Allis',
        'La Crosse',
        'Sheboygan',
        'Wauwatosa',
        'Fond du Lac',
        'New Berlin',
        'Wausau',
        'Brookfield',
        'Greenfield',
        'Beloit'
      ]
    },
    {
      name: 'Wyoming',
      abrv: 'WY',
      cities: [
        'Cheyenne',
        'Casper'
      ]
    }
  ];
  private statesMEX = [
    {
      "name": "Distrito Federal",
      "abrv": "DIF",
      "subdivision": "federal district"
    },
    {
      "name": "Aguascalientes",
      "abrv": "AGU",
      "subdivision": "state"
    },
    {
      "name": "Baja California",
      "abrv": "BCN",
      "subdivision": "state"
    },
    {
      "name": "Baja California Sur",
      "abrv": "BCS",
      "subdivision": "state"
    },
    {
      "name": "Campeche",
      "abrv": "CAM",
      "subdivision": "state"
    },
    {
      "name": "Chiapas",
      "abrv": "CHP",
      "subdivision": "state"
    },
    {
      "name": "Chihuahua",
      "abrv": "CHH",
      "subdivision": "state"
    },
    {
      "name": "Coahuila",
      "abrv": "COA",
      "subdivision": "state"
    },
    {
      "name": "Colima",
      "abrv": "COL",
      "subdivision": "state"
    },
    {
      "name": "Durango",
      "abrv": "DUR",
      "subdivision": "state"
    },
    {
      "name": "Guanajuato",
      "abrv": "GUA",
      "subdivision": "state"
    },
    {
      "name": "Guerrero",
      "abrv": "GRO",
      "subdivision": "state"
    },
    {
      "name": "Hidalgo",
      "abrv": "HID",
      "subdivision": "state"
    },
    {
      "name": "Jalisco",
      "abrv": "JAL",
      "subdivision": "state"
    },
    {
      "name": "Michoacán",
      "abrv": "MIC",
      "subdivision": "state"
    },
    {
      "name": "Morelos",
      "abrv": "MOR",
      "subdivision": "state"
    },
    {
      "name": "México",
      "abrv": "MEX",
      "subdivision": "state"
    },
    {
      "name": "Nayarit",
      "abrv": "NAY",
      "subdivision": "state"
    },
    {
      "name": "Nuevo León",
      "abrv": "NLE",
      "subdivision": "state"
    },
    {
      "name": "Oaxaca",
      "abrv": "OAX",
      "subdivision": "state"
    },
    {
      "name": "Puebla",
      "abrv": "PUE",
      "subdivision": "state"
    },
    {
      "name": "Querétaro",
      "abrv": "QUE",
      "subdivision": "state"
    },
    {
      "name": "Quintana Roo",
      "abrv": "ROO",
      "subdivision": "state"
    },
    {
      "name": "San Luis Potosí",
      "abrv": "SLP",
      "subdivision": "state"
    },
    {
      "name": "Sinaloa",
      "abrv": "SIN",
      "subdivision": "state"
    },
    {
      "name": "Sonora",
      "abrv": "SON",
      "subdivision": "state"
    },
    {
      "name": "Tabasco",
      "abrv": "TAB",
      "subdivision": "state"
    },
    {
      "name": "Tamaulipas",
      "abrv": "TAM",
      "subdivision": "state"
    },
    {
      "name": "Tlaxcala",
      "abrv": "TLA",
      "subdivision": "state"
    },
    {
      "name": "Veracruz",
      "abrv": "VER",
      "subdivision": "state"
    },
    {
      "name": "Yucatán",
      "abrv": "YUC",
      "subdivision": "state"
    },
    {
      "name": "Zacatecas",
      "abrv": "ZAC",
      "subdivision": "state"
    }
  ]
  private iconMarkers = {
    Origin: '<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 833 857.43" style="width: 15px"><defs><style>.cls-1{fill:green;}</style></defs><title>Sin título-1</title><polygon class="cls-1" points="789.67 0 416.5 551.93 43.33 0 789.67 0"/><polygon class="cls-1" points="416.5 698.92 107.18 241.43 0 241.43 416.5 857.43 833 241.43 725.82 241.43 416.5 698.92"/></svg>',
    Destination: '<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 825 895.66" style="width: 15px"><defs><style>.cls-1{fill:red;}</style></defs><title>Sin título-1</title><polygon class="cls-1" points="412.5 332.59 106.15 0 0 0 412.5 447.83 825 0 718.85 0 412.5 332.59"/><polygon class="cls-1" points="412.5 556.5 106.15 223.91 0 223.91 412.5 671.74 825 223.91 718.85 223.91 412.5 556.5"/><polygon class="cls-1" points="412.5 780.42 106.15 447.83 0 447.83 412.5 895.66 825 447.83 718.85 447.83 412.5 780.42"/></svg>',
    Stops: '<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 595.9 937" style="width: 15px"><defs><style>.cls-1{fill:yellow;}</style></defs><title>Sin título-1</title><path class="cls-1" d="M507.82,50C343.26,50,209.87,183.4,209.87,348c0,140.92,97.87,258.91,229.32,289.92L507.82,987l68.62-349.13c131.46-31,229.33-149,229.33-289.92C805.77,183.4,672.37,50,507.82,50Zm0,503.89c-113.74,0-205.94-92.2-205.94-205.94S394.08,142,507.82,142,713.75,234.21,713.75,348,621.55,553.89,507.82,553.89Z" transform="translate(-209.87 -50)"/></svg>',
    InfoWindow: (company) => { return this.bubbleInfo(company) },
    LoadsMarkers: (value: number) => { return this.loadMarker(value) },
    EquipMarker: (type, color) => { return this.equipMarker(type, color) },
    TypeLocation: (type: string, color: string) => { return this.PointMarker(type, color) },
    TruckMarkers: () => this.truckMarker()
  }

  private PointMarker(type: string, color: string): HTMLDivElement {
    let container: HTMLDivElement = document.createElement('div');
    let childrenOne: HTMLDivElement = document.createElement('div');
    let childrenTwo: HTMLDivElement = document.createElement('div');
    container.style.margin = '-3.6em 0 0 -1.3em';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.justifyContent = 'center';
    container.style.alignItems = 'center';

    childrenOne.classList.add('globo')
    childrenOne.style.border = `1px solid ${color}`;
    childrenOne.style.borderRadius = '2em';
    childrenOne.style.padding = '0.4em 0.8em';
    childrenOne.innerHTML = `<b>${type}</b>`;
    childrenTwo.style.width = '0';
    childrenTwo.style.height = '0';
    childrenTwo.style.borderLeft = '15px solid transparent';
    childrenTwo.style.borderRight = '15px solid transparent';
    childrenTwo.style.borderTop = `15px solid ${color}`;
    childrenTwo.style.fontSize = '0';
    childrenTwo.style.lineHeight = '0';
    container.appendChild(childrenOne);
    container.appendChild(childrenTwo);
    return container
  }

  private bubbleInfo({ truck, eq }): HTMLDivElement {
    let containers: HTMLDivElement[] = [];
    let container = document.createElement("div");
    for (let i = 0; 18 > i; i++) {
      let div = document.createElement("div");
      if (containers.length > 0 && containers[0].className == "class0") {
        containers[0].appendChild(div);
        div.classList.add(`class${i}`);
      } else {
        div.classList.add(`class${i}`);
        container.appendChild(div);
      }
      containers.push(div);
    }
    //Title
    containers[2].innerHTML = `<b>${truck.company && truck.company.identity && truck.company.identity.name ? truck.company.identity.name : ''}</b>`;
    // containers[3].innerHTML = "⭐️⭐️⭐️⭐️";
    containers[1].appendChild(containers[2]);
    containers[1].appendChild(containers[3]);
    //Primera Fila
    containers[5].innerHTML = `<span>🚚</span> ${eq} Location`;
    containers[6].innerHTML = `<span>🕰 </span> Available :${new Date(truck.deliveredDate || truck.startDate).toLocaleDateString()}`;
    containers[7].innerHTML = `<span>🚖</span> Total Driver : <b>${truck.totalDriver}</b>`;
    containers[8].innerHTML = "<button class='dxf-btn-primary'>Invite Carrier</button>";
    containers[4].appendChild(containers[5]);
    containers[4].appendChild(containers[6]);
    containers[4].appendChild(containers[7]);
    containers[4].appendChild(containers[8]);
    //Segunda Fila
    containers[10].innerHTML = `<b>Based at :</b> ${truck.company && truck.company.billToInfo && truck.company.billToInfo.city ? truck.company.billToInfo.city : ''}, ${truck.company && truck.company.billToInfo && truck.company.billToInfo.state ? truck.company.billToInfo.state : ''}`;
    containers[11].innerHTML = `<span>🌎</span> <b>Working States</b> :${!truck.workingStates ? '' : truck.workingStates.map(v => `<small>${v}</small>`)}`
    containers[11].style.display = 'contents';
    containers[9].appendChild(containers[10]);
    containers[9].appendChild(containers[11]);
    containers[9].appendChild(containers[12]);
    containers[9].appendChild(containers[13]);
    //Tercera Fila
    containers[15].innerHTML = `<b>DOT :</b> ${truck.company && truck.company.details.dotNumber}`;
    containers[16].innerHTML = `<b>MC#:</b> ${truck.company && truck.company.details.mcNumber}`;
    containers[14].appendChild(containers[15]);
    containers[14].appendChild(containers[16]);
    containers[17].innerHTML = `<button class="dxf-btn-blue">Visit Profile</button>`;
    return container;
  }

  private loadMarker(value: number): HTMLDivElement {
    let mainContainer = document.createElement("div");
    let childContainer = document.createElement("div");
    mainContainer.style.backgroundColor = 'white';
    mainContainer.style.display = 'flex'
    mainContainer.style.borderRadius = '15px 7px 7px 15px';
    mainContainer.style.alignItems = 'center';
    mainContainer.style.minWidth = "2.5em";
    mainContainer.style.paddingRight = '10px';
    mainContainer.style.boxShadow = '3px 3px 5px #00000048';
    mainContainer.classList.add('price')
    childContainer.innerHTML = `<small class="pointer"><i class="fa fa-circle" style="color:red;"></i></small>  <small class="pointer"><b>${value ? '$' + value : 'Negotiable'}</b></small>`;
    mainContainer.appendChild(childContainer);
    return mainContainer
  }

  private equipMarker(type: string, color: string = '#298CCA'): HTMLDivElement {
    let mainContainer = document.createElement("div");
    mainContainer.style.backgroundColor = 'white';
    mainContainer.style.display = 'flex'
    mainContainer.style.borderRadius = '15px 7px 7px 15px';
    mainContainer.style.alignItems = 'center';
    mainContainer.style.minWidth = "2.5em";
    mainContainer.style.paddingRight = '10px';
    mainContainer.style.boxShadow = '3px 3px 5px #00000048';
    mainContainer.classList.add('equipC');
    mainContainer.innerHTML = `<small><i class="fa fa-circle" style="color:${color}; padding-right:5px; "></i></small> <small><b>${type}</b></small>`;
    return mainContainer;
  }

  private truckMarker(): string {
    return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 280.05 791.53" style="width:15px; margin:-20px 0 0 -20px;">' +
      '<defs><style>.cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{opacity:0;}.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-3,.cls-4,.cls-40,.cls-47,.cls-58{mix-blend-mode:multiply;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:red;}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:url(#linear-gradient-13);}.cls-18{fill:url(#linear-gradient-14);}.cls-19{fill:url(#linear-gradient-15);}.cls-20{fill:url(#linear-gradient-16);}.cls-21{fill:url(#linear-gradient-17);}.cls-22{fill:url(#linear-gradient-18);}.cls-23{fill:url(#linear-gradient-19);}.cls-24{fill:url(#linear-gradient-20);}.cls-25{fill:url(#linear-gradient-21);}.cls-26{fill:#f7941e;}.cls-27{fill:url(#linear-gradient-22);}.cls-28{fill:url(#radial-gradient);}.cls-29{fill:url(#linear-gradient-23);}.cls-30{fill:url(#linear-gradient-24);}.cls-31{fill:url(#linear-gradient-25);}.cls-32{fill:url(#linear-gradient-26);}.cls-33{fill:url(#radial-gradient-2);}.cls-34{fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#radial-gradient-3);}.cls-37{fill:url(#linear-gradient-29);}.cls-38,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-55,.cls-57,.cls-69{mix-blend-mode:screen;}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#linear-gradient-39);}.cls-48{fill:url(#linear-gradient-40);}.cls-49{fill:url(#linear-gradient-41);}.cls-50{fill:url(#linear-gradient-42);}.cls-51{fill:url(#linear-gradient-43);}.cls-52{fill:url(#linear-gradient-44);}.cls-53{fill:url(#linear-gradient-45);}.cls-54{fill:url(#linear-gradient-46);}.cls-55{fill:url(#linear-gradient-47);}.cls-56{fill:url(#linear-gradient-48);}.cls-57{fill:url(#linear-gradient-49);}.cls-58{fill:url(#linear-gradient-50);}.cls-59{clip-path:url(#clip-path);}.cls-60{clip-path:url(#clip-path-2);}.cls-61{clip-path:url(#clip-path-3);}.cls-62{clip-path:url(#clip-path-4);}.cls-63{clip-path:url(#clip-path-5);}.cls-64{clip-path:url(#clip-path-6);}.cls-65{clip-path:url(#clip-path-7);}.cls-66{clip-path:url(#clip-path-8);}.cls-67{clip-path:url(#clip-path-9);}.cls-68{clip-path:url(#clip-path-10);}.cls-70{fill:#d6d6d6;}.cls-71{fill:url(#linear-gradient-51);}.cls-72{fill:#e3e3e3;}.cls-73{fill:#c9c9c9;}</style><linearGradient id="linear-gradient" x1="835.69" y1="117.26" x2="865.12" y2="117.26" gradientTransform="matrix(1, 0, 0, -1, -232.79, 909.4)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#363b39"/><stop offset="1" stop-color="#1b1c1c"/></linearGradient>' +
      '<linearGradient id="linear-gradient-2" x1="835.69" y1="208.79" x2="865.12" y2="208.79" gradientTransform="matrix(1, 0, 0, -1, -585.07, 829.4)" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-3" x1="835.69" y1="407.93" x2="865.12" y2="407.93" gradientTransform="matrix(1, 0, 0, -1, -585.07, 829.4)" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-4" x1="835.69" y1="499.46" x2="865.12" y2="499.46" gradientTransform="matrix(1, 0, 0, -1, -585.07, 829.4)" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-5" x1="598.18" y1="117.26" x2="627.62" y2="117.26" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-6" x1="598.18" y1="208.79" x2="627.62" y2="208.79" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-7" x1="598.18" y1="407.93" x2="627.62" y2="407.93" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-8" x1="598.18" y1="499.46" x2="627.62" y2="499.46" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-9" x1="598.2" y1="529.27" x2="862.14" y2="529.27" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#dedede"/><stop offset="0.08" stop-color="#cecece"/><stop offset="0.9" stop-color="#acafae"/><stop offset="1" stop-color="#7b7d7c"/></linearGradient><linearGradient id="linear-gradient-10" x1="545.03" y1="341.69" x2="972.91" y2="769.57" gradientTransform="translate(-585.07 -18.04)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f7f7f7"/><stop offset="0.17" stop-color="#f2f2f2"/><stop offset="0.51" stop-color="#d6d6d6"/>' +
      '    <stop offset="0.85" stop-color="#dfdfdf"/><stop offset="1" stop-color="#dbdbdb"/></linearGradient><linearGradient id="linear-gradient-11" x1="625.73" y1="529.27" x2="643.02" y2="529.27" gradientTransform="translate(-585.07 -18.04)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset="0.23" stop-color="#f5f5f5"/><stop offset="0.61" stop-color="#dadada"/><stop offset="1" stop-color="#b8b8b8"/></linearGradient><linearGradient id="linear-gradient-12" x1="648.33" y1="529.27" x2="665.63" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-13" x1="670.93" y1="529.27" x2="688.23" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-14" x1="693.53" y1="529.27" x2="710.82" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-15" x1="716.13" y1="529.27" x2="733.42" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-16" x1="738.73" y1="529.27" x2="756.03" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-17" x1="761.33" y1="529.27" x2="778.63" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-18" x1="783.93" y1="529.27" x2="801.23" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-19" x1="806.53" y1="529.27" x2="823.82" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-20" x1="829.13" y1="529.27" x2="846.43" y2="529.27" xlink:href="#linear-gradient-11"/><linearGradient id="linear-gradient-21" x1="629.06" y1="87.67" x2="836.16" y2="87.67" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#d1d1d1"/><stop offset="1" stop-color="#a8abaa"/></linearGradient><linearGradient id="linear-gradient-22" x1="629.06" y1="44.69" x2="836.16" y2="44.69" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#363b39"/><stop offset="1" stop-color="#0c0d0d"/></linearGradient><radialGradient id="radial-gradient" cx="732.6" cy="87.63" r="79.46" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#d6d6d6"/></radialGradient><linearGradient id="linear-gradient-23" x1="646.8" y1="126.88" x2="818.31" y2="126.88" xlink:href="#linear-gradient-22"/><linearGradient id="linear-gradient-24" x1="732.61" y1="144.63" x2="732.61" y2="223.16" xlink:href="#linear-gradient-21"/><linearGradient id="linear-gradient-25" x1="732.61" y1="147.04" x2="732.61" y2="223.65" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f7f7f7"/><stop offset="1" stop-color="#dbdbdb"/></linearGradient><linearGradient id="linear-gradient-26" x1="707.87" y1="22.52" x2="730.26" y2="65.86" gradientTransform="matrix(0.93, 0.36, -0.36, 0.93, -61.53, -83.52)" xlink:href="#linear-gradient"/><radialGradient id="radial-gradient-2" cx="837.05" cy="142.53" r="11.55" gradientTransform="translate(-257.23 61.96) scale(1.04 1)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/>' +
      '    <stop offset="1" stop-color="#d2d6d5"/></radialGradient><linearGradient id="linear-gradient-27" x1="829.19" y1="146.27" x2="859.91" y2="146.27" gradientTransform="translate(-232.79 61.96)" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-28" x1="174.5" y1="225.71" x2="196.88" y2="269.05" gradientTransform="matrix(-0.93, 0.36, 0.36, 0.93, 490.29, -83.52)" xlink:href="#linear-gradient"/><radialGradient id="radial-gradient-3" cx="287.33" cy="142.53" r="11.55" gradientTransform="matrix(-1.04, 0, 0, 1, 685.99, 61.96)" xlink:href="#radial-gradient-2"/><linearGradient id="linear-gradient-29" x1="258.41" y1="146.27" x2="289.13" y2="146.27" gradientTransform="matrix(-1, 0, 0, 1, 661.55, 61.96)" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-30" x1="674.63" y1="125.12" x2="793.26" y2="125.12" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#3b3b3b"/><stop offset="1"/></linearGradient><linearGradient id="linear-gradient-31" x1="694.59" y1="21.64" x2="770.64" y2="21.64" gradientTransform="translate(-585.07 -18.04)" xlink:href="#linear-gradient-25"/><linearGradient id="linear-gradient-32" x1="798.84" y1="36.71" x2="812.07" y2="24.87" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#363b39"/></linearGradient><linearGradient id="linear-gradient-33" x1="781.62" y1="32.88" x2="823.98" y2="32.88" xlink:href="#linear-gradient-25"/><linearGradient id="linear-gradient-34" x1="804.35" y1="33.45" x2="806.37" y2="31.64" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-35" x1="808.44" y1="34.46" x2="810.46" y2="32.65" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-36" x1="811.34" y1="36.48" x2="813.36" y2="34.68" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-37" x1="799.87" y1="32.44" x2="801.89" y2="30.63" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-38" x1="796.17" y1="31.43" x2="798.19" y2="29.62" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-39" x1="239.47" y1="36.72" x2="252.7" y2="24.87" gradientTransform="matrix(-1, 0, 0, 1, 674.85, 61.96)" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-40" x1="222.24" y1="32.89" x2="264.6" y2="32.89" gradientTransform="matrix(-1, 0, 0, 1, 674.85, 61.96)" xlink:href="#linear-gradient-25"/><linearGradient id="linear-gradient-41" x1="244.98" y1="33.45" x2="247" y2="31.64" gradientTransform="matrix(-1, 0, 0, 1, 674.85, 61.96)" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-42" x1="249.07" y1="34.46" x2="251.09" y2="32.65" gradientTransform="matrix(-1, 0, 0, 1, 674.85, 61.96)" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-43" x1="251.97" y1="36.48" x2="253.99" y2="34.68" gradientTransform="matrix(-1, 0, 0, 1, 674.85, 61.96)" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-44" x1="240.49" y1="32.44" x2="242.52" y2="30.63" gradientTransform="matrix(-1, 0, 0, 1, 674.85, 61.96)" xlink:href="#linear-gradient-32"/>' +
      '    <linearGradient id="linear-gradient-45" x1="236.8" y1="31.43" x2="238.82" y2="29.62" gradientTransform="matrix(-1, 0, 0, 1, 674.85, 61.96)" xlink:href="#linear-gradient-32"/><linearGradient id="linear-gradient-46" x1="818.53" y1="179.49" x2="865.03" y2="269.52" gradientTransform="translate(-232.79 61.96)" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-47" x1="824.5" y1="197.79" x2="853.85" y2="254.61" xlink:href="#linear-gradient-30"/><linearGradient id="linear-gradient-48" x1="251.84" y1="179.49" x2="298.34" y2="269.53" gradientTransform="matrix(-1, 0, 0, 1, 665.75, 61.96)" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-49" x1="614.07" y1="195.97" x2="645.56" y2="219.75" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0"/><stop offset="1" stop-color="#3b3b3b"/></linearGradient><linearGradient id="linear-gradient-50" x1="732.61" y1="159.72" x2="732.61" y2="240.34" gradientTransform="translate(-232.79 61.96)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#8f8f8f"/></linearGradient><clipPath id="clip-path" transform="translate(-352.28 -80)"><path class="cls-1" d="M482.53,110h-3.2a1.64,1.64,0,1,1,0-3.28h3.2Z"/></clipPath><clipPath id="clip-path-2" transform="translate(-352.28 -80)"><path class="cls-1" d="M517.1,106.69h3.21a1.64,1.64,0,0,1,0,3.28H517.1Z"/></clipPath><clipPath id="clip-path-3" transform="translate(-352.28 -80)"><path class="cls-1" d="M474.35,119.51h-3.21a1.64,1.64,0,1,1,0-3.28h3.21Z"/></clipPath><clipPath id="clip-path-4" transform="translate(-352.28 -80)"><path class="cls-1" d="M525.29,116.23h3.21a1.64,1.64,0,0,1,0,3.28h-3.21Z"/></clipPath><clipPath id="clip-path-5" transform="translate(-352.28 -80)"><path class="cls-1" d="M466.16,129H463a1.64,1.64,0,1,1,0-3.27h3.2Z"/></clipPath><clipPath id="clip-path-6" transform="translate(-352.28 -80)"><path class="cls-1" d="M533.47,125.76h3.21a1.64,1.64,0,1,1,0,3.27h-3.21Z"/></clipPath><clipPath id="clip-path-7" transform="translate(-352.28 -80)"><path class="cls-1" d="M458,138.57h-3.21a1.64,1.64,0,0,1,0-3.27H458Z"/></clipPath><clipPath id="clip-path-8" transform="translate(-352.28 -80)"><path class="cls-1" d="M541.66,135.3h3.21a1.64,1.64,0,0,1,0,3.27h-3.21Z"/></clipPath><clipPath id="clip-path-9" transform="translate(-352.28 -80)"><path class="cls-1" d="M449.79,148.1h-3.2a1.64,1.64,0,1,1,0-3.27h3.2Z"/></clipPath><clipPath id="clip-path-10" transform="translate(-352.28 -80)"><path class="cls-1" d="M549.84,144.83h3.21a1.64,1.64,0,0,1,0,3.27h-3.21Z"/></clipPath><linearGradient id="linear-gradient-51" x1="638.67" y1="246.25" x2="826.55" y2="246.25" gradientTransform="translate(-585.07 -18.04)" xlink:href="#linear-gradient-22"/><image id="image" width="11" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAECAYAAABY+sXzAAAACXBIWXMAAAsSAAALEgHS3X78AAAAF0lEQVQIW2P8////fwYiARMhBciAdooBxtwEBME11VoAAAAASUVORK5CYII="/><image id="image-2" width="11" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAECAYAAABY+sXzAAAACXBIWXMAAAsSAAALEgHS3X78AAAAF0lEQVQIW2Pct2/ffwYiARMhBciAdooBP0YDQXMWu0wAAAAASUVORK5CYII="/><image id="image-3" width="11" height="5" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAFCAYAAACTphZWAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGElEQVQIW2Pct2/ffwYiARMhBchgkCgGANINA0Mp9OJ8AAAAAElFTkSuQmCC"/><image id="image-4" width="10" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAF0lEQVQIW2Pct2/ffwYiABMhBTBAfYUAC2YDQXA9ovUAAAAASUVORK5CYII="/><image id="image-5" width="48" height="88" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAABYCAYAAACzpXSwAAAACXBIWXMAAAsSAAALEgHS3X78AAAEHElEQVR4XtWbTW7rMAyEP8nd9Bot0vufp5coUDSWY0nWW+RRZVznz7EdaYBuCi845HBE0Y5JKVEjPj8/E8DLtQdLQtu26evri67rMMaw2+1MFQTatk3f3990XYcoZrfbGSi8Aj8/PynGiHOOtm0JIQDw8fFh5JkiCTjn0uFwoOs6+r7P/9eBC4oi4JxLfd/T9z0xRg6HAyEEYoyTwUMhBJxzCaDve5xzCIlhGIDpzAueTkCyDuSsS+BwOXh4MgEd/H6/J4SAMQbv/dXABU8h4JxLwzAQQsA5B4D3nhjjRb1PYXMConcJXogYYwgh3BU8bExAZz7GCJAd597MCzYjMM68BD0Mw+zgYSMC+/0+pZSQU1WCjjHOko3G6gQk8957DocD3ntSSoQQHg4eVibgnEuSafH3lFI+pB4NHlYkIA0rWQdOmncprELAOZdEJkC2ypQSwzAsln1YgcDYKkXzSzjOFBYloK0Sjh4fQsjaXzp4WJgAkOd3scthGPKYsHTwsCABkQ6Qm9Z7n7O/Fuy1B26Blo4cTjFGjDG5cdfIPixQAd202uOFyBKH1SU8TADIDaoHM3GdtfGQhMTvY4yklE60vrZ0BLMroKUTQsh+L427RfDwYAUky4JhGLDWZu/fArMI6CFtnHWx0C2yDzMlpLUuB9cWnj+FuwlI40rAwGaeP4VZEhKtC4mtPH8KdxEQ59Fa31oyY9xFAP6OC0vdbefiZgLOuSRjss66BP8s3NzE0qDe+xywPoGfkX24kYBoXzIvfQAV9UBKKa//gOw+z8w+3EBAO48Eb8wx3vEo8QzcJCHRufi+DG9rXRPvwdUKwO9JC2VkXeMiAX3P1c5jrV18QTUXVysgo7GefbaeOC/hLAEZmYETyyxJPnClAqJ7/fpH7LOE7MMVAvpmpZu4JEwSmJKP3iyXkn24UAEtH90DpbiP4CyBqV1+afKBCQJyZYTfgEuVD5ypgAReunzgDIEp+Tzz0nIJZ4e5sXyapuH9/b0o+cCoAto+ZVUI5coHzkhofNsqVT5wRkLWHnmVLh8YVUDmHf2dWsnygREBmfNlaAOKDh4UAbm8NE0DkK+QUN7hpfFHQvr7NVnYloxMYLxt0zIqGZmATJ+ieWvt5qvyOcgExq+FhFDpsHBsYMk4HKsgDVw6TiogDiRESpcPTLgQUNTe5xpOCHjv6fu+GvnAyEZL9/wp5GHOGJOdx1pb7PA2xgv8uk4I4eSz9xpgAZqmOfmrCRaOb9v1R6k1wcrXVoJnvS6di+xCsrSV21gtyNFaa9HjRC04GSVqGeA0LJBn/9r0D/8JWGurcx+BBfKPK0ve/5xD9T2QZ6GmaXh7e6uOwZ87cW3Io4TextWEuo7dCViot4EBXl5fX40xJtXYwKAOslphoV4HAvgHMD+clco4XhkAAAAASUVORK5CYII="/><image id="image-6" width="47" height="88" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABYCAYAAABlAK7VAAAACXBIWXMAAAsSAAALEgHS3X78AAAEWUlEQVR4XtWbS3LqMBBFjyQscFLJKoj3vx7CiFEGGWXAx7akN6DaFryErzHSraJMKKCOWlfdLeGo9XodyrJUZKgJwHq9Dt57Qgi8vb1lMxAVQgDg+/s7TKdTtNZorQFIfUY6eIDVahWm0ymvr68457DWAukO4gAeYLFYhLIsMcbw/v6OMQaAEAIvLy9JDeI/eNFqtQrWWowxWGspigKl9uypzMSf8ADL5TJYa7HWUpYlWmsmkwmQxgBOwsPeRrPZDGstWmvKskQp1dnpmYM4Cw/9DABJzYI+9waA+XyuttstzjnatmW32+G9x3sPwGazOR+BB+iiyIsWi0XQWiProCgKiqIghPCUtHpR5EVVVSnvPc45nHM0TcN2uwVAKvSYs3BV5EWLxSIYYyiKAmMMs9mMyWQy+jq4KvKiqqqUc47dbtfNQF3XXfRhnHVwEzzsBxBCoG1bmqZBBtM0DW3bAvuG78zX3KWbbBPr8/MzhBCQWiAVWWuNMQal1MMsdHPkRR8fHwqgbVvatsV7P1oqvTvyouVyGbz3lGVJURRMJhOstQ9No3dHXjSfzxXsu0/nHN571us1AM65k5+9VYPBi5qmwXtP0zQAnZWcc4PbZ1B4SaF1XXfRl/TpnBu8iA0KD/0AjiIODF+FB4eHvo34zT5DJQh4EDzQpUyxjNiobdvBov8weKnAsoCdcwdNHNyf/x8GD719pI2APhsN0QM9FB7owOUq60AGcY8eDh/vAWQRS9G61z4PhwcOso4MQlroe6rvKPBVVXXNm0Q/ngXv/U3RHwUe+uIVV1uxza3eHw0eOACXiMsVrvf+qPBVVak40/y2eK/RqPAiqbQCL8/huuiPDi+VF/poi3Waprmq9xkdXhS3DWKhEMJVfc9T4CV1St8PHNSBS/UUeJFYRAqWtBGXRv9p8NI2SMMm0HB59J8GLxLQ+ABLCti56D8VPs48MgNiHflF8pTOv2MEHW9SoB/MKT0dXjIP9PBxr3/KOk+HF8VVNrbQKSUFD3304+tf0U8C/pR1TrULScCL4tPlS7rMZODjtCk6t9NKBl4UV13pd+S2gWMlBy/Al1gnKfhz1jlWUvCi2DrxAe2x75OEF+vIRv0vJQf/m3VEx68nBy+SPS301jnOOsnCC7g8/+1UOUn42Dqx57OxDRxuDeH/LjNp+LhQ1XWdT+TlaBDoftOCQ+skC/+X4iYteXg505E0GS/gpOEl68jjuL9JGh4OPe6cQ2vdDSJ5eJHcTeW97850soDfbrcHOT+byMeb81ibzSYkD/+bpNJmBV/XdXf7C2QCX1WVatuW+EbUEEIe8ND3OZJxlFL5wMeFSrJOVvDHf2cDf5wyvff5wMO+WMWHUlnBQ28fY0x+8NC3yVnBi++99/t/Njj3gRQVQqCu6/zgZSeltc4PvmkalFL5eV4kGWewm//H1NfXVyjLMs/I13VNURR5wkOmFRb6PW2Wngf4+fnJcw8L+4zzD+vDVcZtCIS1AAAAAElFTkSuQmCC"/><image id="image-7" width="11" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAECAYAAABY+sXzAAAACXBIWXMAAAsSAAALEgHS3X78AAAATklEQVQIW22MMQpEIRQDR3yt9z+pFgaTLZYvf2EDQyZNWr4B4OnHe+8kudSck39JQmvtZ9dai/fz26sK2yTBNiUJ25dzzvUxBpKQxN6bD3GtVHHt3SbmAAAAAElFTkSuQmCC"/><image id="image-8" width="42" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAECAYAAAD4Za0dAAAACXBIWXMAAAsSAAALEgHS3X78AAAAdElEQVQoU7WPsQoDMQxDFUdTlvz/hyZDEqwOR0x7hSulPYHBWBY8JR2CJJgZJOFb3ZHJOWNzSQJba5eBu/QJNKUUuySw9w53h6Rosc3zTvIlfKVffZLB5e7gnBN7Sinx+AwJAGaGtdbb/VzoX16tNbjGGHgA1dWWZYRxnyIAAAAASUVORK5CYII="/><image id="image-9" width="10" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAUElEQVQIW1WKQQoAIQzEYuvJ/39VD9Y6e1iU3UAYAlP0giTMjMzEzJAEcLf23vkiiVLKrwHqGIO9N5JwdyICd7+nY40Ijq01AOacZOZ1rcUDkH9IaOUJQO8AAAAASUVORK5CYII="/><image id="image-10" width="11" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAECAYAAABY+sXzAAAACXBIWXMAAAsSAAALEgHS3X78AAAAVUlEQVQIW1WNQQoAIQwDs1o8+P+PCl4U29lTZTcwh5CQPAARoYgQoIhQKUWAWmtyd2X+jDHIYpZS6RNba8ndf9RaBaj3rnPOxeac9x6QmWnvfe+/Iy/v1moibS83TAAAAABJRU5ErkJggg=="/><image id="image-11" width="58" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAECAYAAADfyyz1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAkElEQVQoU71QQQ7DIAxzA6gc+P8/kbggErwT1cbWdZva+ZTYicFZSNLM0HtHCAEksYd32tX6t7vrumLk6r1jyTmTJEhCRH5+bGgicjhzBWZv5xxGLpLwtVaoKlQVMcaHhVH/g/PeY8b8+aP+nkspbblUFb6UAjODmUFVdw1mozP5EAJaa0/ap0d6xQHYcpkZbi6GxwGgDhIVAAAAAElFTkSuQmCC"/><image id="image-12" width="11" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAECAYAAABY+sXzAAAACXBIWXMAAAsSAAALEgHS3X78AAAAWUlEQVQIW1WNQQoEMRAC3U4H5v9PDbkk2DqnaVjBg1SBP9uuKkjCnBOSIAm2IQkRAduwjVxr9YiIFj/pi23kOQckQRLP86Cq/jrG6Jfcezcg2cA2MhP33uYvtq9pI7UG/AwAAAAASUVORK5CYII="/><image id="image-13" width="11" height="5" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAFCAYAAACTphZWAAAACXBIWXMAAAsSAAALEgHS3X78AAAAUklEQVQIW42NMQ7AIAwDXcjM/3/JBEti3CmIVh1qybJyUuxLkkiilAJJSOWdTBJsjIG/sjnn4zuz1rqbkxtJnF5rgSRaa3B3RMS29d4/J99cEm4iZlEYhwmrtgAAAABJRU5ErkJggg=="/><image id="image-14" width="75" height="5" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAFCAYAAAANHBH2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAkElEQVQ4T+2SsRICIQxE95JrKfj//+JPoIBk1kJx9FROvdPC8VWEDWFmsxOPgCQAQETO5yWjexG5q73Do3++CUmoKro3JDHnnNfe/Tkxl1Ku3OtudpZbvqy3pukTCdpz5k2y3B2tNZgZzAwhhKFBvVZVuPuw51Xt2b6t2preiTGi1orWGmqtmFJK+63ihyGJA/Jfn/bx+GQIAAAAAElFTkSuQmCC"/><image id="image-15" width="11" height="5" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAFCAYAAACTphZWAAAACXBIWXMAAAsSAAALEgHS3X78AAAAV0lEQVQIW43MMQ7DMBADwc1Bnf7/TlVScQeKLgwZLhIgU7HhfnzDNhGBJCICANsctmlzTv7V1lp8K5/qu94kkZlUFb13AKoKSUhi7/3sNsZ4npnJL7a5AIe3SzM7UIE9AAAAAElFTkSuQmCC"/>' +
      '    <image id="image-16" width="10" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAVklEQVQIW1WNQQrAMBAC3SQE8v+X5pDDwqo9NbTeHEYM2yYJSZCE1hpsY86JL4+9tyUhIvDG9h28fWQmqgokUVUYY0AS1lp/fs6BJNhG7x2ZeS9JXvEBekBbJU0BHicAAAAASUVORK5CYII="/><image id="image-17" width="91" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAAECAYAAADh7kO7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAkElEQVQ4T92RsQ7DIAxEzyiGgf//UAYGBLY7gdIqRaFRVaVvO+7Ow0FmZiICVQUzw8ywyicd4P973nv0bVUVlFKyfoyIlg/v80Q0Sd6X1U06zrnRNTNspRS01iAiCCEMY8+39ZnMTDPz29wrM/9K98iPMY5tW2vYcs4QkfEwKx/x6wwzo9a69DlnM1c1gKdtHxGvvgFD1CqoAAAAAElFTkSuQmCC"/><image id="image-18" width="11" height="4" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAECAYAAABY+sXzAAAACXBIWXMAAAsSAAALEgHS3X78AAAAVElEQVQIW12MQQpDMRQCJ5+E3P+qgSwCT+0qpb9uHERtSSIJ24wxsI1tkmCb53lIQhL6WoskALTWvvyrm/VzDlWFJOacr9frl/veG0lIoqpexf/RB5WIZjIqxGyvAAAAAElFTkSuQmCC"/><image id="image-19" width="10" height="5" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAYAAAB8ZH1oAAAACXBIWXMAAAsSAAALEgHS3X78AAAAUklEQVQIW2WMwQrAIAxD36Tgzf//SfFesdlhVNwWKGkCeZcecUoSpRSyl4RFBJL4eq2VtdY+671zEvNPYmaLiNcyc2sNd2fOibtjY4wfDSD7pN52XGMAjMiWGQAAAABJRU5ErkJggg=="/><image id="image-20" width="108" height="5" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAAFCAYAAACgnQlfAAAACXBIWXMAAAsSAAALEgHS3X78AAAApUlEQVRIS+2VwQrDIAyGv0gRoae+/xv24t0Ss8NQBtPWwQoO9l2U8MdEf4JiTwAQEcr+jJZGRBrK32bkLe7EOVd7KOuSc0ZVUVW8983Eq8Z7Rl/lFf66NiGE6o2qAiD7vpuZYWY45y6OeGe0+KzM3H93wlJKHMfBuq7dC3wSn0Hbi39b2/sKRs87q7FtW/UmpQTAEmOsghKclZmn4Q5evRERcs48APtEt9tZR+PwAAAAAElFTkSuQmCC"/><image id="image-21" width="11" height="5" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAFCAYAAACTphZWAAAACXBIWXMAAAsSAAALEgHS3X78AAAAWElEQVQIW32NMQ4EIQwDJ4iGkv//kIY+CPuKE6u9W2ktRfE04/A3ANimlMLhk8NVEnvv61pr2EbS48cY49V871USmclai8yk9/6zdF+uc87LEBEc/rfa5gMXTGn2yekZtAAAAABJRU5ErkJggg=="/></defs><title>dxf-truck</title><g class="cls-2"><g id="Capa_1" data-name="Capa 1"><g class="cls-3"><g class="cls-4"><image width="47" height="88" transform="translate(-0.28 93)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABYCAYAAABlAK7VAAAACXBIWXMAAAsSAAALEgHS3X78AAABkUlEQVR4Xu3UQW7DMAxE0Z+i97+yuyjSuqhjUhIlDoX8tRcPA8qP4zgo1g/48+4roa4WfqjjX53FA3SXv0U/U8PfPcA/cICPq6+SaoKDxvLW7+4SDvn45rXPZeG71z6XcfMhcFiPD4PDWnwoHNbhw+GwBj8FDvPx0+AwF2/Bh5uF98CHVoc5+CVwiMcvg0M83ioMDrF4z+qhReE98NDVIQafAocYvNUUOIzjPatPawTvgU9bHcbw6fXi01eHfrzVdDj04T2rL6kV74EvWR3a8VK14KVWhza8XF683Orgx0vmwUuuDj68bBH4lNXBxntOJi0Lb5W2OtzjpVeHseVTV4cxfHqv8PInA/3Lp58M9OMlusJbJyOxOmy4fJla8TInA//x1r1L1bq8VC14qZOBNrxcZ3ypewf/8nInA368ZNvjJU8GfvHlHiv4lpfNwsueDNh46d74rO7w0vcO3/iSv0nY9GzkTwY2Xb5E2+FL3DtsuHyZtsKXuXfYbPlSvfFZnfGlHitstHy5tsCXu3covvwXZIIpwceVHGYAAAAASUVORK5CYII="/></g><g class="cls-4"><image width="48" height="88" transform="translate(96.72 93)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAABYCAYAAACzpXSwAAAACXBIWXMAAAsSAAALEgHS3X78AAABjUlEQVR4Xu3U227DIBCE4bHf/53pTeOUgmGN9zAr8UtVbvtllhyllIJvB5J1ov6ny5+/FJ2/nwfabz8F5ERd74SoV/kPAPprfKJD9ACfRggayAgAjH+VKCAzADD/aQ1FSAAAMUIKAGQId8gTADBHAM6IpwCADLECAIgQqwCABPEGABAg3gKAYIQGAAhEaAGAIIQmAJAhVNMGSFJdwQIgWUENYQEAHBFWALcsAS4rWAIAB4Q1wDwPgOkKHgDAEOEFMMsTYLKCJ8Akb4D6Ct4AQIYQFwGQJF4hCqC2QhRAkmiFSIDKCpEASdMV2AHTogGvzygaIGl4RgyAVyswACTdrsACWF6BBbBcJkD3jJgAS2fEBFiKDfB4BTbArOYdZAM0MQIenREjYFZ1RhkBVawA8RmxAsRlBVzvgBkgOiNmgKgNMG56RuyAaZkBBcgBGJ5RBsCwDYguC+D2HWQB3LYBwZVMgO47yATotgHRZQM07yAboGkDossIqN5BRkDVBkSXFXC9g6yAqw2ILjvg+AHGqTGva8eujgAAAABJRU5ErkJggg=="/></g><g class="cls-4"><use transform="translate(44.72 102)" xlink:href="#image"/><image width="42" height="4" transform="translate(50.72 102)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAECAYAAAD4Za0dAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGklEQVQoU2P8////f4YhAJgIKRgsYNSh1AYAiUQEBD4nZKAAAAAASUVORK5CYII="/><use transform="translate(441 182)" xlink:href="#image"/><image width="10" height="4" transform="translate(36.72 111)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAF0lEQVQIW2P8////fwYiABMhBTBAfYUAhswEBAIoHrgAAAAASUVORK5CYII="/><image width="58" height="4" transform="translate(42.72 111)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAECAYAAADfyyz1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAG0lEQVQoU2P8////f4YRAJgIKRguYNSjww0AAIqABAQKjmlrAAAAAElFTkSuQmCC"/><use transform="translate(449 191)" xlink:href="#image"/><use transform="translate(380 201)" xlink:href="#image"/><image width="75" height="4" transform="translate(34.72 121)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAECAYAAADGQMJTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAIUlEQVQ4T2P8////f4ZRQBRgIqRgFCDAaGCRAEYDiwQAAMvMBARBpwh1AAAAAElFTkSuQmCC"/><use transform="translate(457 201)" xlink:href="#image"/><image width="11" height="5" transform="translate(19.72 130)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAFCAYAAACTphZWAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGElEQVQIW2P8////fwYiARMhBchgkCgGAHv5BAYJU0QxAAAAAElFTkSuQmCC"/><image width="91" height="5" transform="translate(26.72 130)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAAFCAYAAAAqspAeAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJklEQVQ4T2P8////f4ZRQBfAREjBKKAeGA1sOoLRwKYjGA1sOgIAifAEBggNid4AAAAASUVORK5CYII="/><image width="10" height="5" transform="translate(113.72 130)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAYAAAB8ZH1oAAAACXBIWXMAAAsSAAALEgHS3X78AAAAF0lEQVQIW2P8////fwYiABMhBTAwgAoBK9EEBjymy1sAAAAASUVORK5CYII="/><use transform="translate(364 220)" xlink:href="#image"/><image width="107" height="4" transform="translate(18.72 140)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAECAYAAACJHcGDAAAACXBIWXMAAAsSAAALEgHS3X78AAAAI0lEQVQ4T2P8////f4ZRMCQAEyEFo2DwgNHIGkJgNLKGEAAAzkQEBCjtKaIAAAAASUVORK5CYII="/><use transform="translate(474 220)" xlink:href="#image"/></g></g><g class="cls-4"><g class="cls-4"><image width="48" height="88" transform="translate(74.72 17)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAABYCAYAAACzpXSwAAAACXBIWXMAAAsSAAALEgHS3X78AAABsklEQVR4Xu2aMW7DMBAEx07+Zejj8tOYIhASSLZIikfeHuEBVMnFzt4CanxLKRGR5/OZAL5zP1RiC72xLMsthMA+OPyGB/ELvAoOf+FBVKAk+IaUwLvg8Do8iAicBYf34QHu716MoiU8OF/gymT2uAi0tv6f4ROyDA+DBazDw0CBHuFhkECv8DBAoGd46CzQOzx0FMiFt6KLQEl4i/ahg8DI8GAsMDo8GAvksA4PhgIl7ffARKAkfI/2wUDAMzwYCHjTJODdPjQIKISHBgEVLgmotA8XBZSoFlBqHy4I5BgZHioFStofTZVAjtHtQ4WAYvtQIZDDo30oFFBtHwoFcni1DwUCyu1DgUAOz/bBQMCbUwH1+UDjBbznAycCEdqHhgsotA8NAiq8FMjNR6V9mPUCkTgIRJoPzHiBaFQJqM0HdgK5/StSdQFFigUU5wMVAqrMI2Dx7ykP5rlAVLICyvOBAgF17hDzC7xxegH1+cAsE4rMvAIR9g8zXyAK4QW+Ho/H4SMWZf8wwQU+At4cBCLtH2a8QDTmEoi2f5jtAhH5CLiTUmJd15RSIuIT/gLhBX4AlJsxB9quyeIAAAAASUVORK5CYII="/></g><g class="cls-4"><image width="47" height="88" transform="translate(172.72 17)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABYCAYAAABlAK7VAAAACXBIWXMAAAsSAAALEgHS3X78AAABsklEQVR4Xu3awU7EMAyE4VnEi/XFu48WDhBUSlNPGju2pfwSJy7fmCwHBPZ9L6UUZPz6BID3+13w07ZtLyTpVcq3+zigFn3ILx64HgDEHfEHD7QHAPFG/MPXMoz4aH3jDng3bGbNy9ckqOdPoXn5moSTxlkm4oG4A8Rnc4xBSkM1oy5fY2DMQK268ECsAd14IM6AR3ggxoDHeMB/wBAe8B0wjAf8BqjgAW6Admp4Ju3rq+KZ62sOUMUDcweo4wFugEYmeCaN65vhmeuPDjDDA/YDTPHWmeMtr2+Ot2wK3ur6U/AAN6C3aXim3utPxWtffyqeqef60/Ga15+OZ2Kv74LXur4Lnom5vhte4/pueCbp+q740eu74kdzx0vXv3s67viRUuBb1w+Bl55OqxD4p4XBS9e/ejph8E9aeK2kp3MuFF7q/O5T4c+Fw/c8nXD4ntLhj+8+JJ59OiHxbAtvEfN0wuLvqh/alPhaaLz0dELjpRbeq67/q/Qq9F8Pnrbw1rV+ZabAt1p4r9Lgr959GvxVC+9VKvz53afCn1t4rxZ+ZscPbTr8sYX3KiW+vvuU+NoXiBY7rzouq7QAAAAASUVORK5CYII="/></g><g class="cls-4"><use transform="translate(119.72 26)" xlink:href="#image-2"/><image width="42" height="4" transform="translate(126.72 26)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAECAYAAAD4Za0dAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGklEQVQoU2Pct2/ff4YhAJgIKRgsYNSh1AYAh8ADQWNwVQwAAAAASUVORK5CYII="/><use transform="translate(164.72 26)" xlink:href="#image-4"/><use transform="translate(464 116)" xlink:href="#image-2"/><image width="58" height="4" transform="translate(118.72 36)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAECAYAAADfyyz1AAAACXBIWXMAAAsSAAALEgHS3X78AAAAG0lEQVQoU2Pct2/ff4YRAJgIKRguYNSjww0AAMXtA0FKdtCRAAAAAElFTkSuQmCC"/><use transform="translate(525 116)" xlink:href="#image-2"/><use transform="translate(103.72 45)" xlink:href="#image-3"/><image width="75" height="5" transform="translate(109.72 45)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAFCAYAAAANHBH2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAJUlEQVQ4T2Pct2/ff4ZRQBRgIqRgFCDAaGCRAEYDiwQwGlgkAAAODANDFgMI6gAAAABJRU5ErkJggg=="/><use transform="translate(533 125)" xlink:href="#image-3"/><use transform="translate(448 135)" xlink:href="#image-4"/><image width="91" height="4" transform="translate(101.72 55)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAAECAYAAADh7kO7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAIklEQVQ4T2Pct2/ff4ZRQBfAREjBKKAeGA1sOoLRwKYjAAB2NgNBKkX2DAAAAABJRU5ErkJggg=="/><use transform="translate(541 135)" xlink:href="#image-2"/><image width="10" height="5" transform="translate(87.72 64)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAYAAAB8ZH1oAAAACXBIWXMAAAsSAAALEgHS3X78AAAAF0lEQVQIW2Pct2/ffwYiABMhBTAwgAoBkSEDQ0JkHGgAAAAASUVORK5CYII="/><image width="108" height="5" transform="translate(93.72 64)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAAFCAYAAACgnQlfAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJ0lEQVRIS2Pct2/ff4ZRMGQAEyEFo2BwgdEIG2JgNMKGGBiNsCEGAGzwA0OngKLXAAAAAElFTkSuQmCC"/><use transform="translate(549 144)" xlink:href="#image-3"/></g></g><g class="cls-4"><use transform="translate(74.72 17)" xlink:href="#image-5"/></g>' +
      '<g class="cls-4"><use transform="translate(172.72 17)" xlink:href="#image-6"/></g><g class="cls-4"><use transform="translate(119.72 26)" xlink:href="#image-7"/><use transform="translate(126.72 26)" xlink:href="#image-8"/><use transform="translate(164.72 26)" xlink:href="#image-9"/><use transform="translate(111.72 36)" xlink:href="#image-10"/><use transform="translate(118.72 36)" xlink:href="#image-11"/><use transform="translate(172.72 36)" xlink:href="#image-12"/><use transform="translate(103.72 45)" xlink:href="#image-13"/><use transform="translate(109.72 45)" xlink:href="#image-14"/><use transform="translate(180.72 45)" xlink:href="#image-15"/><use transform="translate(95.72 55)" xlink:href="#image-16"/><use transform="translate(101.72 55)" xlink:href="#image-17"/><use transform="translate(188.72 55)" xlink:href="#image-18"/><use transform="translate(87.72 64)" xlink:href="#image-19"/><use transform="translate(93.72 64)" xlink:href="#image-20"/><use transform="translate(196.72 64)" xlink:href="#image-21"/></g><path class="cls-5" d="M625.78,754.13H609.45a6.54,6.54,0,0,0-6.55,6.54v63a6.54,6.54,0,0,0,6.55,6.54h16.33a6.54,6.54,0,0,0,6.55-6.54v-63A6.54,6.54,0,0,0,625.78,754.13Z" transform="translate(-352.28 -80)"/><rect class="cls-6" x="250.62" y="582.6" width="29.43" height="76.03" rx="6.55"/><rect class="cls-7" x="250.62" y="383.45" width="29.43" height="76.04" rx="6.55"/><rect class="cls-8" x="250.62" y="291.92" width="29.43" height="76.04" rx="6.55"/><path class="cls-9" d="M388.28,754.13H371.94a6.54,6.54,0,0,0-6.55,6.54v63a6.54,6.54,0,0,0,6.55,6.54h16.34a6.55,6.55,0,0,0,6.55-6.54v-63A6.54,6.54,0,0,0,388.28,754.13Z" transform="translate(-352.28 -80)"/><path class="cls-10" d="M388.28,662.6H371.94a6.54,6.54,0,0,0-6.55,6.55v62.93a6.55,6.55,0,0,0,6.55,6.55h16.34a6.55,6.55,0,0,0,6.55-6.55V669.15A6.55,6.55,0,0,0,388.28,662.6Z" transform="translate(-352.28 -80)"/><path class="cls-11" d="M388.28,463.45H371.94a6.55,6.55,0,0,0-6.55,6.55v62.94a6.55,6.55,0,0,0,6.55,6.55h16.34a6.55,6.55,0,0,0,6.55-6.55V470A6.55,6.55,0,0,0,388.28,463.45Z" transform="translate(-352.28 -80)"/><path class="cls-12" d="M388.28,371.92H371.94a6.55,6.55,0,0,0-6.55,6.55v62.94a6.55,6.55,0,0,0,6.55,6.55h16.34a6.55,6.55,0,0,0,6.55-6.55V378.47A6.55,6.55,0,0,0,388.28,371.92Z" transform="translate(-352.28 -80)"/><path class="cls-13" d="M610.21,871.53H389.43A15.52,15.52,0,0,1,373.9,856V326.46a15.52,15.52,0,0,1,15.53-15.52H610.21a15.51,15.51,0,0,1,15.53,15.52V856A15.52,15.52,0,0,1,610.21,871.53Z" transform="translate(-352.28 -80)"/><rect class="cls-14" x="37.15" y="246.46" width="220.79" height="529.55"/><rect class="cls-15" x="42.03" y="246.46" width="14.38" height="529.55"/><rect class="cls-16" x="64.64" y="246.46" width="14.38" height="529.55"/><rect class="cls-17" x="87.24" y="246.46" width="14.38" height="529.55"/><rect class="cls-18" x="109.84" y="246.46" width="14.37" height="529.55"/><rect class="cls-19" x="132.44" y="246.46" width="14.37" height="529.55"/><rect class="cls-20" x="155.03" y="246.46" width="14.39" height="529.55"/><rect class="cls-21" x="177.64" y="246.46" width="14.38" height="529.55"/><rect class="cls-22" x="200.24" y="246.46" width="14.38" height="529.55"/><rect class="cls-23" x="222.84" y="246.46" width="14.37" height="529.55"/><rect class="cls-24" x="245.44" y="246.46" width="14.38" height="529.55"/><path class="cls-25" d="M396.27,175.58V128.69c0-33.4,27.09-48.69,60.48-48.69h86.14c33.4,0,60.48,15.29,60.48,48.69v46.89l-13.44,42-179.3,1.68Z" transform="translate(-352.28 -80)"/><path class="cls-26" d="M410.68,123.07a1.9,1.9,0,0,0,1.55-1.9,14.72,14.72,0,0,1,3.94-9.93,1.9,1.9,0,0,0,.18-2.43h0a1.74,1.74,0,0,0-2.57.21A18,18,0,0,0,409,121.15a1.73,1.73,0,0,0,1.72,1.92Z" transform="translate(-352.28 -80)"/><path class="cls-26" d="M588.94,123.07a1.88,1.88,0,0,1-1.54-1.9,14.78,14.78,0,0,0-3.95-9.93,1.89,1.89,0,0,1-.19-2.43h0a1.76,1.76,0,0,1,2.59.21,18,18,0,0,1,4.81,12.13,1.73,1.73,0,0,1-1.72,1.92Z" transform="translate(-352.28 -80)"/><path class="cls-27" d="M542.89,80H456.75c-33.39,0-60.48,15.29-60.48,48.69v4.61c0-11.71,3.39-20,9.14-25.91,10.68-13.68,29.65-20.17,51.34-20.17h86.14c21.69,0,40.66,6.49,51.33,20.17,5.77,5.9,9.15,14.2,9.15,25.91v-4.61C603.37,95.29,576.29,80,542.89,80Z" transform="translate(-352.28 -80)"/><path class="cls-28" d="M402.26,174.84l7.84-46.15c0-31.48,32.62-34.87,46.65-34.87h86.14c14,0,46.65,3.39,46.65,34.87l7.83,46.15-17.56,29-159.2,1.49Z" transform="translate(-352.28 -80)"/><path d="M583.21,216.65a394.25,394.25,0,0,0-166.78,0l-1.71.38-.26-1.74a147.73,147.73,0,0,1-1.27-21.17,170.42,170.42,0,0,0-.81-17.37l-.14-1.33,1.27-.41a291,291,0,0,1,89.31-14c25.54,0,52.7,3.21,83.06,9.82l1.29.28v1.32c0,17,0,27.26-2,42.84L585,217Z" transform="translate(-352.28 -80)"/><path class="cls-29" d="M583.55,215.05a395.64,395.64,0,0,0-167.47,0c-2.07-14-.55-24.91-2.07-38.48,55.3-17.54,107.66-18.06,171.51-4.15C585.52,189.44,585.52,199.57,583.55,215.05Z" transform="translate(-352.28 -80)"/><g class="cls-4"><use transform="translate(427 97)" xlink:href="#image-5"/></g><g class="cls-4"><use transform="translate(525 97)" xlink:href="#image-6"/></g><path class="cls-30" d="M405.88,305.48h187.6s9.81-6.86,9.82-10.19c0-21.76,0-40.36.06-53.18,0-11.76-13.43-24.51-13.43-24.51s-12-11.34-90.12-11c-52.69-.22-76.09,7.61-89.18,12.68-6.22,2.4-14.34,13.64-14.34,22.83,0,16.12,0,39.67.07,53.18C396.37,302.84,405.88,305.48,405.88,305.48Z" transform="translate(-352.28 -80)"/><path class="cls-31" d="M415.42,305.48s-6.45-17-6.45-44.63c0-19.21,6.39-42.77,6.39-42.77,6-2,45.2-9.07,84.44-9.08s78.46,6.37,84.48,8.43c0,0,6.4,22.67,6.4,43.42,0,29.17-6.44,44.63-6.44,44.63Z" transform="translate(-352.28 -80)"/><path class="cls-32" d="M595.22,187.09s9.08,5.58,6.23,13.74-19.09,20.7-15.37,10.27S593.16,189.85,595.22,187.09Z" transform="translate(-352.28 -80)"/><path class="cls-33" d="M626.09,206.88c-2.29-3-23.37-9.3-23.37-9.3-4.16-1.32-5.59,2.24-6.07,5.25l30.22,8.86A5.38,5.38,0,0,0,626.09,206.88Z" transform="translate(-352.28 -80)"/><path class="cls-34" d="M596.65,202.83a21.83,21.83,0,0,0-.25,3.7l29.69,7.11a8.71,8.71,0,0,0,.78-1.95Z" transform="translate(-352.28 -80)"/><path class="cls-35" d="M404.31,187.09s-9.07,5.58-6.22,13.74,19.09,20.7,15.37,10.27S406.38,189.85,404.31,187.09Z" transform="translate(-352.28 -80)"/><path class="cls-36" d="M373.44,206.88c2.31-3,23.38-9.3,23.38-9.3,4.16-1.32,5.58,2.24,6.06,5.25l-30.2,8.86A5.34,5.34,0,0,1,373.44,206.88Z" transform="translate(-352.28 -80)"/><path class="cls-37" d="M402.88,202.83a20.66,20.66,0,0,1,.25,3.7l-29.69,7.11a8.72,8.72,0,0,1-.76-1.95Z" transform="translate(-352.28 -80)"/><path class="cls-38" d="M448.82,209.4a397,397,0,0,1,104.68.35l7-41.35a463.17,463.17,0,0,0-118.63-.32Z" transform="translate(-352.28 -80)"/><polygon class="cls-39" points="185.56 7.22 109.52 7.22 114.17 0 180.89 0 185.56 7.22"/><path class="cls-40" d="M585.34,108.33A6.13,6.13,0,0,1,581,106.7c-6-5.78-13-7.67-21.14-9.86-2-.55-4.11-1.11-6.26-1.75-4.93-1.49-7.31-3.74-7.09-6.73.3-3.73,5.05-6.38,7.4-6.7a32.13,32.13,0,0,1,4.46-.3c14.83,0,27.3,9.64,32,13.78,3.94,3.48,3.21,6.86,2.72,8.16a8.52,8.52,0,0,1-7.75,5Z" transform="translate(-352.28 -80)"/><path class="cls-41" d="M554.24,83.94c-2.49.34-10.84,5.68,0,8.94s20.41,4.48,28.34,12.16c3.42,3.3,13-2.23,6.22-8.18S568.84,82,554.24,83.94Z" transform="translate(-352.28 -80)"/><path class="cls-42" d="M575.11,94.83c0,.56-1.29,1-2.9,1s-2.9-.45-2.9-1,1.3-1,2.9-1S575.11,94.28,575.11,94.83Z" transform="translate(-352.28 -80)"/><path class="cls-43" d="M579.21,95.84c0,.56-1.31,1-2.91,1s-2.9-.46-2.9-1,1.31-1,2.9-1S579.21,95.28,579.21,95.84Z" transform="translate(-352.28 -80)"/><path class="cls-44" d="M582.11,97.86c0,.56-1.31,1-2.9,1s-2.91-.45-2.91-1,1.31-1,2.91-1S582.11,97.3,582.11,97.86Z" transform="translate(-352.28 -80)"/><path class="cls-45" d="M570.63,93.82c0,.56-1.3,1-2.9,1s-2.9-.45-2.9-1,1.29-1,2.9-1S570.63,93.26,570.63,93.82Z" transform="translate(-352.28 -80)"/><path class="cls-46" d="M566.94,92.81c0,.56-1.3,1-2.91,1s-2.91-.45-2.91-1,1.31-1,2.91-1S566.94,92.25,566.94,92.81Z" transform="translate(-352.28 -80)"/><path class="cls-47" d="M416.09,108.33a6.14,6.14,0,0,0,4.32-1.63c6-5.78,13-7.67,21.13-9.86,2-.55,4.13-1.11,6.26-1.75q7.43-2.24,7.09-6.73c-.29-3.73-5-6.38-7.4-6.7a31.93,31.93,0,0,0-4.46-.3c-14.82,0-27.29,9.64-32,13.78-3.92,3.48-3.2,6.86-2.71,8.16a8.5,8.5,0,0,0,7.75,5Z" transform="translate(-352.28 -80)"/><path class="cls-48" d="M447.19,83.94c2.49.34,10.84,5.68,0,8.94S426.74,97.36,418.81,105c-3.42,3.3-12.95-2.23-6.22-8.18S432.59,82,447.19,83.94Z" transform="translate(-352.28 -80)"/><path class="cls-49" d="M426.31,94.83c0,.56,1.3,1,2.9,1s2.9-.45,2.9-1-1.29-1-2.9-1S426.31,94.28,426.31,94.83Z" transform="translate(-352.28 -80)"/><path class="cls-50" d="M422.22,95.84c0,.56,1.3,1,2.9,1s2.91-.46,2.91-1-1.31-1-2.91-1S422.22,95.28,422.22,95.84Z" transform="translate(-352.28 -80)"/><path class="cls-51" d="M419.32,97.86c0,.56,1.29,1,2.9,1s2.9-.45,2.9-1-1.3-1-2.9-1S419.32,97.3,419.32,97.86Z" transform="translate(-352.28 -80)"/><path class="cls-52" d="M430.8,93.82c0,.56,1.3,1,2.9,1s2.91-.45,2.91-1-1.31-1-2.91-1S430.8,93.26,430.8,93.82Z" transform="translate(-352.28 -80)"/><path class="cls-53" d="M434.5,92.81c0,.56,1.29,1,2.9,1s2.9-.45,2.9-1-1.3-1-2.9-1S434.5,92.25,434.5,92.81Z" transform="translate(-352.28 -80)"/><path class="cls-54" d="M599.35,229.6l-5.59,8.67s4.87,27.21,0,57l9.54-9.22h0c0-21.75,0-31.13.06-43.95C603.36,237.85,601.59,233.48,599.35,229.6Z" transform="translate(-352.28 -80)"/><path class="cls-55" d="M603.3,286.07h0c0-16.68,0-26.09,0-35.35-2.55,1.77-5.16,3.67-7.71,5.64a184.24,184.24,0,0,1-1.87,38.94Z" transform="translate(-352.28 -80)"/><path class="cls-56" d="M400.31,229.6l5.57,8.67s-4.86,27.21,0,57l-9.53-9.22h0c0-21.75-.05-31.13-.06-43.95C396.29,237.85,398.06,233.48,400.31,229.6Z" transform="translate(-352.28 -80)"/>' +
      '   < path class="cls-57" d = "M396.35,286.07h0c0-16.68,0-26.09-.05-35.35,2.56,1.77,5.17,3.67,7.72,5.64a184.16,184.16,0,0,0,1.86,38.94Z" transform = "translate(-352.28 -80)" /> <path class="cls-58" d = "M448,293.74a2.25,2.25,0,0,1-2.25,2.25h0a2.25,2.25,0,0,1-2.25-2.25v-69a2.25,2.25,0,0,1,2.25-2.25h0a2.25,2.25,0,0,1,2.25,2.25Zm10.82-69a2.25,2.25,0,0,0-2.25-2.25h0a2.26,2.26,0,0,0-2.27,2.25v69a2.26,2.26,0,0,0,2.27,2.25h0a2.25,2.25,0,0,0,2.25-2.25Zm10.82,0a2.26,2.26,0,0,0-2.26-2.25h0a2.26,2.26,0,0,0-2.26,2.25v69a2.25,2.25,0,0,0,2.26,2.25h0a2.26,2.26,0,0,0,2.26-2.25Zm10.81,0a2.26,2.26,0,0,0-2.26-2.25h0a2.25,2.25,0,0,0-2.25,2.25v69a2.24,2.24,0,0,0,2.25,2.25h0a2.25,2.25,0,0,0,2.26-2.25Zm10.82,0a2.26,2.26,0,0,0-2.26-2.25h0a2.26,2.26,0,0,0-2.26,2.25v69A2.25,2.25,0,0,0,489,296h0a2.26,2.26,0,0,0,2.26-2.25Zm10.81,0a2.26,2.26,0,0,0-2.26-2.25h0a2.26,2.26,0,0,0-2.26,2.25v69a2.26,2.26,0,0,0,2.26,2.25h0a2.26,2.26,0,0,0,2.26-2.25Zm10.81,0a2.25,2.25,0,0,0-2.25-2.25h0a2.25,2.25,0,0,0-2.25,2.25v69a2.24,2.24,0,0,0,2.25,2.25h0a2.25,2.25,0,0,0,2.25-2.25Zm10.82,0a2.26,2.26,0,0,0-2.26-2.25h0a2.26,2.26,0,0,0-2.26,2.25v69a2.26,2.26,0,0,0,2.26,2.25h0a2.25,2.25,0,0,0,2.26-2.25Zm10.81,0a2.25,2.25,0,0,0-2.26-2.25h0a2.25,2.25,0,0,0-2.25,2.25v69a2.25,2.25,0,0,0,2.25,2.25h0a2.24,2.24,0,0,0,2.26-2.25Zm10.82,0a2.26,2.26,0,0,0-2.26-2.25h0a2.26,2.26,0,0,0-2.26,2.25v69a2.25,2.25,0,0,0,2.26,2.25h0a2.26,2.26,0,0,0,2.26-2.25Zm10.81,0a2.25,2.25,0,0,0-2.25-2.25h0a2.26,2.26,0,0,0-2.26,2.25v69A2.25,2.25,0,0,0,553.9,296h0a2.25,2.25,0,0,0,2.25-2.25Z" transform = "translate(-352.28 -80)" /> <g class="cls-4" > <g class="cls-59" > <use transform="translate(472 106)" xlink: href = "#image-7" /> </g><use transform="translate(479 106)" xlink:href="#image-8"/ > <g class="cls-60" > <use transform="translate(517 106)" xlink: href = "#image-9" /> </g><g class="cls-61"><use transform="translate(464 116)" xlink:href="#image-10"/ > </g><use transform="translate(471 116)" xlink:href="#image-11"/ > <g class="cls-62" > <use transform="translate(525 116)" xlink: href = "#image-12" /> </g><g class="cls-63"><use transform="translate(456 125)" xlink:href="#image-13"/ > </g><use transform="translate(462 125)" xlink:href="#image-14"/ > <g class="cls-64" > <use transform="translate(533 125)" xlink: href = "#image-15" /> </g><g class="cls-65"><use transform="translate(448 135)" xlink:href="#image-16"/ > </g><use transform="translate(454 135)" xlink:href="#image-17"/ > <g class="cls-66" > <use transform="translate(541 135)" xlink: href = "#image-18" /> </g><g class="cls-67"><use transform="translate(440 144)" xlink:href="#image-19"/ > </g><use transform="translate(446 144)" xlink:href="#image-20"/ > <g class="cls-68" > <use transform="translate(549 144)" xlink: href = "#image-21" /> </g></g > <g class="cls-69" > <path class="cls-70" d = "M587.17,115.47a84.16,84.16,0,0,1,3,8.3c.78,2.51,1.6,5.47,2.37,8.65s1.48,6.59,2.16,10,1.19,6.88,1.58,10.12.73,6.29.9,8.92a78.45,78.45,0,0,1,.21,8.82,79.7,79.7,0,0,1-3-8.31c-.8-2.51-1.61-5.46-2.38-8.63s-1.47-6.6-2.16-10-1.18-6.87-1.58-10.12-.73-6.29-.89-8.91A81.52,81.52,0,0,1,587.17,115.47Z" transform = "translate(-352.28 -80)" /> </g><g class="cls-69"><path class="cls-70" d="M412.2,115.47a78.44,78.44,0,0,1-.21,8.82c-.17,2.62-.48,5.67-.9,8.91s-1,6.68-1.58,10.12-1.36,6.84-2.16,10-1.58,6.12-2.37,8.63a80.93,80.93,0,0,1-3,8.31,78.45,78.45,0,0,1,.21-8.82c.17-2.63.47-5.68.9-8.92s1-6.68,1.58-10.12,1.37-6.84,2.17-10,1.59-6.14,2.38-8.65A79.86,79.86,0,0,1,412.2,115.47Z" transform="translate(-352.28 -80)"/ > </g><rect class="cls-71" x="53.6" y="225.48" width="187.88" height="5.45"/ > <path d="M571.42,179.63a203.07,203.07,0,0,0-83-15.17c0-1.15,0-2.3,0-3.46a206.33,206.33,0,0,1,84.33,15.45C572.3,177.51,571.86,178.57,571.42,179.63Z" transform = "translate(-352.28 -80)" /> <path d="M518.93,164.67c0,2.08-9.13,3.76-20.41,3.76s-20.41-1.68-20.41-3.76,9.14-3.74,20.41-3.74S518.93,162.6,518.93,164.67Z" transform = "translate(-352.28 -80)" /> <path class="cls-72" d = "M603.36,280.12a1.94,1.94,0,0,0,2-1.9V262.48a2,2,0,0,0-2-1.91Z" transform = "translate(-352.28 -80)" /> <path class="cls-73" d = "M396.29,280.12a1.93,1.93,0,0,1-2-1.9V262.48a2,2,0,0,1,2-1.91Z" transform = "translate(-352.28 -80)" /> </g></g > </svg>';
  }

  constructor(public micro: Microservices) { }

  getIconMarkers() {
    return this.iconMarkers;
  }

  getLocationType() {
    return [
      { key: 'Military base', value: 'Base militar' },
      { key: 'Airport', value: 'Aeropuerto' },
      { key: 'Port', value: 'Puerto' },
      { key: 'CFS', value: 'Estación de contenedores de carga' },
      { key: 'Residential', value: 'Residencial' },
      { key: 'Commercial', value: 'Comercial' },
      { key: 'Yard', value: 'Patio / Almacén Externo' }
    ];
  }

  getStatesUSA() {
    return this.statesUSA.filter(item => item.cities.length > 0);
  }

  getStatesMex() {
    return this.statesMEX;
  }

  getAllCities() {
    const array = [];
    for (let state of this.statesUSA) {
      const cities = [...state.cities];
      for (let city of cities) {
        city = `${city}, ${state.abrv}`;
        array.push(city);
      }
    }
    return array;
  }

  getOptionsZipcode() {
    return this.optionsZipcode;
  }

  getAccessorials() {
    return [
      { key: 'Extendable/Strech', value: 'Extendable/Strech' },
      { key: 'Air-Ride', value: 'Air-Ride' },
      { key: 'Team', value: 'Team' },
      { key: 'Expedited', value: 'Acelerado' },
      { key: 'Hazardous Material', value: 'Material peligroso' },
      { key: 'E-Tracks', value: 'E-Tracks' },
      { key: 'Liftgate', value: 'Liftgate' },
      { key: 'Lumper', value: 'Lumper' },
      { key: 'Conestoga', value: 'Conestoga' },
      { key: 'Hotshot', value: 'Hotshot' }
    ];
  }

  getNewAccessorials() {
    return [
      { key: 'LAYOVER', value: 'Estadía (por días)' },
      { key: 'LABOR', value: 'Mano de obra' },
      { key: 'STPCHRG', value: 'STPCHRG' },
      { key: 'HANDLEFEE', value: 'HANDLEFEE' },
      { key: 'STORAGE', value: 'Almacenamiento' },
      { key: 'CORRECTION', value: 'CORRECTION' },
      { key: 'SATURDAY', value: 'SATURDAY' },
      { key: 'LABEL', value: 'LABEL' },
      { key: 'OVERWIDTH', value: 'Sobreanchura' },
      { key: 'RECLASS', value: 'RECLASS' },
      { key: 'OVER8TO12', value: 'OVER8TO12' },
      { key: 'DIVERSION', value: 'Desviación' },
      { key: 'WHITEDEL', value: 'WHITEDEL' },
      { key: 'OVERLENGTH', value: 'OVERLENGTH' },
      { key: 'OVERSIZE', value: 'OVERSIZE' },
      { key: 'SINGLESHIP', value: 'SINGLESHIP' },
      { key: 'APPT', value: 'APPT' },
      { key: 'CONTRUC', value: 'CONTRUC' },
      { key: 'INSIDE', value: 'INSIDE' },
      { key: 'LIFTGATE', value: 'LIFTGATE' },
      { key: 'LIMITED', value: 'LIMITED' },
      { key: 'RESIDENTA', value: 'RESIDENTA' },
      { key: 'SORTSEG', value: 'SORTSEG' },
      { key: 'BLIND SHIPMENT', value: 'Embarque a ciegas' },
      { key: 'MATERIALS', value: '' },
      { key: 'CFS', value: 'Estación de contenedores de carga' },
      { key: 'HAZMAT', value: 'Material peligroso' },
      { key: 'TAR', value: 'TAR' },
      { key: 'TEAMTRANS', value: 'TEAMTRANS' },
      { key: 'HCDFEE', value: 'HCDFEE' },
      { key: 'UPS', value: 'UPS' },
      { key: 'DOCFEE', value: 'DOCFEE' },
      { key: 'CUBIC', value: 'CUBIC' },
      { key: 'DOCKUNLOAD', value: 'DOCKUNLOAD' },
      { key: 'OVER12TO16', value: 'OVER12TO16' },
      { key: 'OVER16TO20', value: 'OVER16TO20' },
      { key: 'UPLFT', value: 'UPLFT' },
      { key: 'DRYRUN', value: 'DRYRUN' },
      { key: 'HandUn', value: 'HandUn' },
      { key: 'DETENTION', value: 'Estadías (por horas)' },
      { key: 'OVRWGHT', value: 'OVRWGHT' },
      { key: 'OVERHEIGHT', value: 'Sobrealtura' }
    ];
  }

  getOtherAccessorilas() {
    return [
      { key: 'Appointment - Delivery', value: 'Cita - Entrega' },
      { key: 'Appointment - Pickup', value: 'Cita - Recogida' },
      { key: 'Blind Shipment', value: 'Embarque a ciegas' },
      { key: 'CFS Pickup - Pickup', value: 'Recogida en estación de contenedores de carga - Recogida' },
      { key: 'Construction Site - Delivery', value: 'Sitio en construcción - Entrega' },
      { key: 'Correction of Terms', value: 'Corrección de términos' },
      { key: 'Cubic Capacity', value: 'Capacidad cúbica' },
      { key: 'Detention', value: 'Estadías (por horas)' },
      { key: 'Diversion', value: 'Desviación' },
      { key: 'Document Fee', value: 'Tarifa por documentos' },
      { key: 'Dock Unload', value: 'Descarga en muelle' },
      { key: 'Dry Run', value: 'Complemento de flete' },
      { key: 'Handling Fee', value: 'Cargo por maniobras de carga/descarga' },
      { key: 'Hand Unloading', value: 'Descargando de forma manual' },
      { key: 'Hazardous Material - Pickup', value: 'Material peligroso - Recogida' },
      { key: 'High Cost Area Fee', value: 'Tarifa para área de alto costo' },
      { key: 'Inside Delivery - Delivery', value: 'Entrega interna - Entrega' },
      { key: 'Inside Pickup - Pickup', value: 'Recogida interna - Recogida' },
      { key: 'Labeling', value: 'Etiquetado' },
      { key: 'Labor', value: 'Mano de obra' },
      { key: 'Layover', value: 'Estadía (por días)' },
      { key: 'Liftgate - Delivery', value: 'Compuerta elevadiza - Entrega' },
      { key: 'Liftgate - Pickup', value: 'Compuerta elevadiza - Recogida' },
      { key: 'Limited Access Delivery - Delivery', value: 'Entrega con acceso limitado - Entrega' },
      { key: 'Limited Access Pickup - Pickup', value: 'Recogida con acceso limitado - Recogida' },
      { key: 'Crating & Material', value: 'Embalaje y material' },
      { key: 'Over Length - 12ft but less than 16ft - Delivery', value: 'Over Length - 12ft but less than 16ft - Delivery' },
      { key: 'Over Length - 16ft but less than 20ft - Delivery', value: 'Over Length - 16ft but less than 20ft - Delivery' },
      { key: 'Over Length - 8ft  but less than 12ft - Delivery', value: 'Over Length - 8ft  but less than 12ft - Delivery' },
      { key: 'Overheight', value: 'Sobrealtura' },
      { key: 'Over Length Charge - Delivery', value: 'Over Length Charge - Delivery' },
      { key: 'Oversize Charge', value: 'Cargo por tamaño sobredimensionado' },
      { key: 'Overwidth', value: 'Sobreanchura' },
      { key: 'Overweight Fee', value: 'Tarifa por sobrepeso' },
      { key: 'Re-Class', value: 'Re-clasificar' },
      { key: 'Residential - Delivery', value: 'Residencial - Entrega' },
      { key: 'Residential - Pickup', value: 'Residencial - Recogida' },
      { key: 'Saturday Pickup', value: 'Recogida el sábado' },
      { key: 'Single Shipment Charge - Pickup', value: 'Carga única - Recogida' },
      { key: 'Sort and Segregation', value: 'Clasificación y segregación' },
      { key: 'Storage', value: 'Almacenamiento' },
      { key: 'Stop Charge - Delivery', value: 'Cargo por recolección/entrega adicional - Entrega' },
      { key: 'Tarp Fee - Pickup', value: 'Tarifa por uso de lona - Recogida' },
      { key: 'Team Transit  - Pickup', value: 'Team Transit  - Pickup' },
      { key: 'Uplift min max - Rating', value: 'Elevación mínima máxima - Calificación' },
      { key: 'UPS Orders', value: 'Ordenes de UPS' },
      { key: 'White Glove Service', value: 'Servicio de guantes blancos (cuidado extremo)' },
    ];
  }

  getEquipmentTypeDrayage() {
    return [
      { key: 'Standard', value: 'Estándar' },
      { key: 'High Cube', value: 'Contenedor High Cube' },
      { key: 'Reefer', value: 'Reefer' },
      { key: 'Flatrack', value: 'Parrilla plana' },
      { key: 'Open Top', value: 'Tapa abierta' },
      { key: 'ISO Tank', value: 'Tanque ISO' },
      { key: 'Platform', value: 'Plataforma' }
    ];
  }

  getNewAccsDrayage() {
    return [
      { key: "Additional stop fee", value: '' },
      { key: "Bonded Cargo", value: '' },
      { key: "Chassis rental(per day)", value: '' },
      { key: "Chassis split", value: '' },
      { key: "Clean trailer", value: '' },
      { key: "Congestion fee", value: '' },
      { key: "Detention", value: '' },
      { key: "Demurrage", value: '' },
      { key: "Dry run", value: '' },
      { key: "Drop trailer", value: '' },
      { key: "Floor Loading / Unloading", value: '' },
      { key: "Genset", value: '' },
      { key: "Hazmat", value: '' },
      { key: "Include Pierr pass", value: '' },
      { key: "Layover", value: '' },
      { key: "Lift Fee", value: '' },
      { key: "Overlength", value: '' },
      { key: "Overweight", value: '' },
      { key: "Overwidth", value: '' },
      { key: "Other", value: '' },
      { key: "Placard removal", value: '' },
      { key: "Per diem", value: '' },
      { key: "Pier pass", value: '' },
      { key: "Pre pull", value: '' },
      { key: "Redelivery charge", value: '' },
      { key: "Reefer", value: '' },
      { key: " Residential", value: '' },
      { key: "Scale ticket", value: '' },
      { key: "Stop charge", value: '' },
      { key: "Seal", value: '' },
      { key: "Tarps", value: '' },
      { key: "Tolls", value: '' },
      { key: "Tonu", value: '' },
      { key: "Tri Axle", value: '' },
      { key: "Transloading", value: '' },
    ];
  }

  getServicesDrayagePickup() {
    return [
      { key: 'Pre pull', value: 'Resguardo de contenedor' },
      { key: 'Tri Axle', value: 'Remolque de 3 ejes' },
      { key: 'Overweight', value: 'Overweight' },
      { key: 'Overwidth', value: 'Sobreanchura' },
      { key: 'Overlength', value: 'Overlength' },
      { key: 'Scale Ticket', value: 'Pesaje' },
      { key: 'Tarps', value: 'Lonas' },
      { key: 'Genset', value: 'Generador para refrigerado' },
      { key: 'Reefer', value: 'Reefer' },
      { key: 'Congestion fee', value: 'Tarifa de congestión' },
      { key: 'Clean trailer', value: 'Limpieza de contenedor' }
    ];
  }

  getServicesDrayageReturn() {
    return [
      { key: 'Demurrage', value: 'Días de almacenaje dentro del puerto' },
      { key: 'Dry Run', value: 'Complemento de flete' },
      { key: 'Layover', value: 'Estadía (por días)' },
      { key: 'Tolls', value: 'Peajes' },
      { key: 'Bonded Cargo', value: 'Carga consolidada' },
      { key: 'Seal', value: 'Sello' },
      { key: 'Placard Removal', value: 'Retiro de etiquetas' },
      { key: 'Include Pier pass', value: 'Include Pier pass' }
    ];
  }

  getTourValue() {
    return this.TOUR;
  }

  getAllAccessorials() {
    return [...this.getAccessorials(), ...this.getNewAccessorials()];
  }

  getEquipments() {
    return [
      {
        name: 'Auto Carrier',
        key: 'Auto Carrier',
        icon: 'IconEquipment3.svg',
        accessorials: ['Air-Ride', 'Team', 'Acelerado', 'Hazardous Material', 'E-Tracks', 'Liftgate', 'Lumper', 'Conestoga', 'Hotshot']
      },
      {
        name: 'Double Drop',
        key: 'Double Drop',
        icon: 'IconEquipment3.svg',
        accessorials: ['Extendable/Strech']
      },
      {
        name: 'Dump Trailer',
        key: 'Dump Trailer',
        icon: 'IconEquipment3.svg',
        accessorials: ['Extendable/Strech', 'Air-Ride', 'Team', 'Hazardous Material', 'Conestoga', 'Hotshot']
      },
      {
        name: 'Flatbed',
        key: 'Flatbed',
        icon: 'IconEquipment3.svg',
        accessorials: ['Extendable/Strech', 'Air-Ride', 'Team', 'Hazardous Material', 'Conestoga', 'Hotshot']
      },
      {
        key: 'Flatbed w/Pallet Exchange',
        name: 'Flatbed con intercambio de palets',
        icon: 'IconEquipment3.svg',
        accessorials: ['Air-Ride', 'Lumper']
      },
      {
        key: 'Flatbed w/Sides',
        name: 'Flatbed con laterales',
        icon: 'IconEquipment3.svg',
        accessorials: ['Team', 'Lumper']
      },
      {
        key: 'Flatbed w/Tarps',
        name: 'Flatbed con lonas',
        icon: 'IconEquipment3.svg',
        accessorials: ['Air-Ride', 'Lumper']
      },
      {
        name: 'Hopper Bottom',
        key: 'Hopper Bottom',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'Hotshot',
        key: 'Hotshot',
        icon: 'IconEquipment3.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'Power Only',
        key: 'Power Only',
        icon: 'IconEquipment3.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'Maxi',
        key: 'Maxi',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'Reefer',
        key: 'Reefer',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        key: 'Reefer w/Pallet Exchange',
        name: 'Reefer con intercambio de palets',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'RGN',
        key: 'RGN',
        icon: 'IconEquipment3.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        key: 'Step Deck',
        name: 'Stepdeck',
        icon: 'IconEquipment3.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'Tanker',
        key: 'Tanker',
        icon: 'IconEquipment2.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'Van',
        key: 'Van',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'Dry Van',
        key: 'Dry Van',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        name: 'Sprinter Van',
        key: 'Sprinter Van',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        key: 'Van Air-Ride',
        name: 'Van Air-Ride',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        key: 'Van w/Curtains',
        name: 'Van con cortinas',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        key: 'Van w/Pallet Exchange',
        name: 'Van con intercambio de palets',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      },
      {
        key: 'Box Truck',
        name: 'Box Truck',
        icon: 'IconEquipment1.svg',
        accessorials: ['Air-Ride', 'Hazardous Material', 'Lumper']
      }
    ];
  }

  getPickupTimes() {
    return this.pickupTimes;
  }

  getReferenceTypes() {
    return [
      { name: 'BOL Number', type: 'bolNumber' },
      { name: 'PRO Number', type: 'proNumber' }
    ];
  }

  getUnidades() {
    return this.unidades;
  }

  getOpens() {
    return this.opens;
  }

  setOpens(i: number) {
    this.opens[i] = !this.opens[i];
  }

  getPermits() {
    return this.permits;
  }

  /**
   *@function filter steps menu by role, accesslevel
   * */

  getStepsFilterMenu(user: any): Array<any> {
    const listStep = this.stepsMenuBroker;
    return listStep.filter(step => {
      if (step.role) {
        if (step.role.includes(user.role)) {
          return step;
        }
      } else {
        if (step.accesslevel.includes(user._accessLevel)) {
          return step;
        }
      }
    });
  }


  getRoutes() {
    return this.routes;
  }

  getLoadsType() {
    return [
      { key: 'A-FRAME', value: 'A-FRAME' },
      { key: 'Bags', value: 'Bolsas' },
      { key: 'Bales', value: 'Pacas' },
      { key: 'Barrel', value: 'Barril' },
      { key: 'Basket', value: 'Canasta' },
      { key: 'Bins', value: 'Contenedores' },
      { key: 'Box', value: 'Caja' },
      { key: 'Break bulk', value: 'Carga a granel' },
      { key: 'Bundle', value: 'Manojo' },
      { key: 'Cans', value: 'Latas' },
      { key: 'Cart', value: 'Carrito' },
      { key: 'Cartons', value: 'Cajas de cartón' },
      { key: 'Case', value: 'Estuche' },
      { key: 'Chest', value: 'Cofre' },
      { key: 'Container', value: 'Contenedor' },
      { key: 'Crate', value: 'Cajón' },
      { key: 'Cylinder', value: 'Cilindro' },
      { key: 'Drum', value: 'Barril' },
      { key: 'Gallons', value: 'Galones' },
      { key: 'Gaylords', value: 'Contenedor corrugado a granel' },
      { key: 'Halfpallets', value: 'Halfpallets' },
      { key: 'Hopper', value: 'Tolva' },
      { key: 'Jerricans', value: 'Bidones' },
      { key: 'Lift van', value: 'Camioneta elevadiza' },
      { key: 'Loose', value: 'A granel' },
      { key: 'Package', value: 'Paquete' },
      { key: 'Pails', value: 'Cubos' },
      { key: 'Pallet', value: 'Palet' },
      { key: 'Piece', value: 'Pieza' },
      { key: 'Racks', value: 'Estantes' },
      { key: 'Reel', value: 'Carrete' },
      { key: 'Roll', value: 'Rollo' },
      { key: 'Skid', value: 'Rampa de descarga' },
      { key: 'Stacks', value: 'Pilas' },
      { key: 'Totes', value: 'Totalizadores' },
      { key: 'Truckload', value: 'Camión de carga' },
      { key: 'Tube', value: 'Tubo' },
      { key: 'Tubs', value: 'Tinas' },
      // { key: 'U-box', value: this.micro.dictionary?.U_BOX },
      { key: 'Unit' },
      { key: 'Vehicle', value: 'Vehículo' },
      { key: 'Wheels', value: 'Ruedas' }
    ];
  }

  getStages() {
    return [
      {
        key: 'stage1',
        description: 'En ruta para recoger',
      },
      {
        key: 'stage2',
        description: 'En el lugar de recogida',
      },
      {
        key: 'stage3',
        description: 'Cargando',
      },
      {
        key: 'stage31',
        description: 'Cargado'
      },
      {
        key: 'stage4',
        description: 'En tránsito',
      },
      {
        key: 'stage5',
        description: 'En el lugar de entrega',
      },
      {
        key: 'stage6',
        description: 'Descarga'
      },
      {
        key: 'stage7',
        description: 'Completado',
      },
    ];
  }

  getBlockchainStages() {
    return this.blockchainStages;
  }

  getShipment() {
    return this.shipment;
  }

  getLoadDetails() {
    return this.shipment;
  }

  getSorts() {
    return [
      {
        sortBy: 'Sin ordenar',
      },
      {
        sortBy: 'Creación',
        sortDirection: 1
      },
      {
        sortBy: 'Estado',
        sortDirection: 1
      },
      {
        sortBy: 'Origen',
        sortDirection: 1
      },
      {
        sortBy: 'Destino',
        sortDirection: 1
      },
      {
        sortBy: 'Tarifa final',
        sortDirection: 1
      },
      {
        sortBy: 'Recogida',
        sortDirection: 1
      },
      {
        sortBy: 'Distancia',
        sortDirection: 1
      },
      {
        sortBy: 'Unidad de transporte',
        sortDirection: 1
      },
      {
        sortBy: 'Parcial',
        sortDirection: 1
      },
      {
        sortBy: 'Peso',
        sortDirection: 1
      },
    ];
  }

  getinvoicesListSorts() {
    return [
      {
        name: 'Sort',
        key: 'SORT',
        values: [
          {
            name: 'Creación',
            value: 'Creation'
          },
          {
            name: 'Tarifa final',
            value: 'Rate'
          },
          {
            name: 'Delivery',
            value: 'DeliveryDate'
          },
          {
            name: 'Fecha de vencimiento',
            value: 'DueDate'
          }
        ]
      }
    ];
  }
  // await dexFreight.Enums.getEnum("CLASS_MX" || "CLASS_USA"); Now is coming from backend
  getClassList() {
    return [
      { key: '1.1 Mass Explosive Hazard', value: '1.1 Peligro de explosión masiva' },
      { key: '1.2 Projection Hazard', value: '1.2 Peligro de proyección' },
      { key: '1.3 Fire and/or Minor Blast/Minor Projection Hazard', value: '1.3 Peligro de incendio y/o explosión leve/proyección menor' },
      { key: '1.4 Minor Explosion Hazard', value: '1.4 Peligro de explosión menor' },
      { key: '1.5 Very Insensitive with Mass Explosion Hazard', value: '1.5 Muy insensible con peligro de explosión masiva' },
      { key: '1.6 Extremely Insensitive: No Mass Explosion Hazard', value: '1.6 Extremadamente insensible: sin peligro de explosión masiva' },
      { key: '2.1 Flammable Gases', value: '2.1 Gases inflamables' },
      { key: '2.2 Nonflammable Gases', value: '2.2 Gases no inflamables' },
      { key: '2.3 Toxic Gases', value: '2.3 Gases tóxicos' },
      { key: '3 Flammable and Combustible Liquids', value: '3 Líquidos inflamables y combustibles' },
      { key: '4.1 Flammable Solids', value: '4.1 Sólidos inflamables' },
      { key: '4.2 Spontaneously Combustible', value: '4.2 Espontáneamente combustible' },
      { key: '4.3 Dangerous When Wet', value: '4.3 Peligroso cuando está mojado' },
      { key: '5.1 Oxidizing Substances', value: '5.1 Sustancias oxidantes' },
      { key: '5.2 Organic Peroxides', value: '5.2 Peróxidos orgánicos' },
      { key: '6.1 Toxic Substances', value: '6.1 Sustancias tóxicas' },
      { key: '6.2 Infectious Substances', value: '6.2 Sustancias infecciosas' },
      { key: '7 Radioactive Material', value: '7 Material radiactivo' },
      { key: '8 Corrosives', value: '8 Corrosivos' },
      { key: '9 Miscellaneous', value: '9 Varios' },
    ];
  }

  getRoles() {
    return this.roles;
  }

  getUSStates() {
    return this.US_STATES;
  }

  getPickupLocationTypes() {
    return [
      { key: "Port", value: 'Puerto' },
      { key: "Rail Ramp", value: 'Rampa de carril' },
      { key: "Terminal", value: 'Terminal' },
      { key: "Yard", value: 'Patio / Almacén Externo' },
      { key: "Depot", value: 'Almacén' }
    ];
  }

  getDestinationLocationTypes() {
    return [
      { key: "Business", value: 'Negocio' },
      { key: "Residential", value: 'Residencial' },
      { key: "Mall", value: 'Centro comercial' },
      { key: "Military Base", value: 'Base militar' },
      { key: "Limited Access", value: 'Acceso limitado' },
      { key: "Warehouse", value: 'Bodega' }
    ];
  }
  getDestinationLocationTypesMX() {
    return [
      { key: "Aeropuerto", value: "Aeropuerto" },
      { key: "Auction", value: "Auction" },
      { key: "Empresa (con montacarga)", value: "Empresa (con montacarga)" },
      { key: "Empresa (sin montacarga)", value: "Empresa (sin montacarga)" },
      { key: "Área de construcción", value: "Área de construcción" },
      { key: "Granja/ Rancho/ Hacienda", value: "Granja/ Rancho/ Hacienda" },
      { key: "Terminal de carga", value: "Terminal de carga" },
      { key: "Parque o complejo turístico/ de entrenamiento", value: "Parque o complejo turístico/ de entrenamiento" },
      { key: "Edificio gubernamentral", value: "Edificio gubernamentral" },
      { key: "Base militar", value: "Base militar" },
      { key: "Lugar con acceso imitado", value: "Lugar con acceso imitado" },
      { key: "Institución religiosa", value: "Institución religiosa" },
      { key: "Residencia", value: "Residencia" },
      { key: "Escuela/ Universidad", value: "Escuela/ Universidad" },
      { key: "Depósito/ Instalación de almacenaje", value: "Depósito/ Instalación de almacenaje" },
      { key: "Feria/ Centro de convenciones", value: "Feria/ Centro de convenciones" },
      { key: "Parque industrial", value: "Parque industrial" },
      { key: "Bodega", value: "Bodega" },
      { key: "Yarda", value: "Yarda" },
    ];
  }
  getPickupLocationTypesMX() {
    return [
      { key: "Rampa", value: "Rampa" },
      { key: "Montacarga", value: "Montacarga" },
      { key: "Muelle de carga", value: "Muelle de carga" },
      { key: "Grúa miscelánea - otros", value: "Grúa miscelánea - otros" },
      { key: "Gato hidráulico ", value: "Gato hidráulico " },
      { key: "Terminal de carga ", value: "Terminal de carga " },
      { key: "Puerto ", value: "Puerto" },
      { key: "Bodega ", value: "Bodega" },
      { key: "Yarda", value: "Yarda" }
    ];
  }
}
